import React, { useState, useEffect } from 'react';
import { useMenListing, useListingObserver, menProfileKey } from '../hooks/useMenListing';
import { captureAttribution } from '../utils/attribution';
import { motion } from "framer-motion";
import { ImageFormComponent } from './menimagesform';
import {
    Base64, calculateDaysHoursMinutes, fillerprofiledata,
    packages, DatalistInput, SmartImageComponent,
    postData, fetchData,
    saveEmailToLocalStorage,
    calculateDaysHoursMinutesdata,
    safeParse,
    getLocalStorageItem,
    setLocalStorageItem,
    removeLocalStorageItem,
    malequestions,
    tanzaniaBrandPreferences,
    tanzaniaResidentialAreas,
    ugandaBrandPreferences,
    ugandaResidentialAreas,
    kenyaMonthlyIncome,
    tanzaniaMonthlyIncome,
    ugandaMonthlyIncome,
    kenyaMonthlyIncomeAfterTax,
    tanzaniaMonthlyIncomeAfterTax,
    ugandaMonthlyIncomeAfterTax,
    generateUUID
} from './misc.js';
import "./../leaguespartan.css";
import './SignupViewport.css';
import './SignupSpouseEditor.css';
import { useParams, Link, useNavigate } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha'
import { GeneralModal, Loader } from './profile.js';
import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';
import Cookies from 'js-cookie';
import { ChatInterfaceMan, loadprofile, primeCallAudioFromUserGesture } from '../pages/Chats.js';
import { createChatSelectionTracker } from './chatSelection.js';
import PasswordInput from './components/Password.js';
import MDEditor from '@uiw/react-md-editor';
import MemberWelcomeVideo from './MemberWelcomeVideo.js';
import ExpiredAccountModal, { EXPIRED_ACCOUNT_LOGIN_MESSAGE } from './ExpiredAccountModal.js';
import SapphireLoginPromoImage from '../media/sapphire-package-video-calling.jpeg';
import { MoreVertical } from 'lucide-react';
import { trackEvent, getOrCreateVisitorId } from '../utils/bridge.js';

const log_error_url = '/api/log-error';
const SAPPHIRE_LOGIN_PROMO_COOKIE = 'sapphireLoginPromoSeen';

function isExpiredAccountLoginResponse(data) {
    return data?.expired === true || data?.responsecode === 1001 || data?.message === EXPIRED_ACCOUNT_LOGIN_MESSAGE || data?.message === 'Your account is expired'
}

function setLoginCookies(email, authCookie) {
    Cookies.set('auth', authCookie || 'current', { expires: 1 })
    Cookies.set('email', email, { expires: 1 })
    saveEmailToLocalStorage(email)
}



function parseUserDateInput(dateStr) {
    if (!dateStr || typeof dateStr !== 'string') {
        return null;
    }

    const trimmed = dateStr.trim();
    const match = trimmed.match(/^(\d{1,2})\/(\d{1,2})\/(\d{1,4})$/);
    if (!match) {
        return null;
    }

    const [, dayRaw, monthRaw, yearRaw] = match;
    const day = Number(dayRaw);
    const month = Number(monthRaw);
    const numericYear = Number(yearRaw);

    if (!Number.isInteger(day) || !Number.isInteger(month) || !Number.isInteger(numericYear)) {
        return null;
    }

    const fullYear = yearRaw.length <= 2 ? 2000 + numericYear : numericYear;
    const parsedDate = new Date(fullYear, month - 1, day);

    if (
        parsedDate.getFullYear() !== fullYear
        || parsedDate.getMonth() !== month - 1
        || parsedDate.getDate() !== day
    ) {
        return null;
    }

    return {
        day: String(day).padStart(2, '0'),
        month: String(month).padStart(2, '0'),
        year: String(fullYear).slice(-2),
    };
}

function normalizeDateString(dateStr) {
    const parsed = parseUserDateInput(dateStr);
    if (!parsed) {
        return null;
    }

    return `${parsed.day}/${parsed.month}/${parsed.year}`;
}
function isValidAmount(value) {
    const parsedAmount = Number(value);
    return Number.isFinite(parsedAmount) && parsedAmount > 0;
}

function normalizeAmountInput(value) {
    if (value === null || value === undefined) {
        return '';
    }

    return String(value).replace(/,/g, '').trim();
}

function isValidDateString(dateStr) {
    return normalizeDateString(dateStr) !== null;
}

function notifyInvalidPromptInput({ action, field, value, email }) {
    return postData(log_error_url, {
        type: `${action}_prompt_invalid_input`,
        message: `Invalid ${field} input received: ${String(value)}`,
        email,
    }).catch((err) => {
        console.error('Failed to notify invalid prompt input:', err);
    });
}

async function promptForValidAmount(person, action) {
    while (true) {
        const amount = window.prompt(`Enter ${action} amount:`);

        if (amount === null) {
            return null;
        }

        const normalizedAmount = normalizeAmountInput(amount);

        if (isValidAmount(normalizedAmount)) {
            return normalizedAmount;
        }

        await notifyInvalidPromptInput({
            action,
            field: 'amount',
            value: amount,
            email: person?.EMAIL,
        });
        alert('Please enter a valid amount greater than 0.');
    }
}

async function promptForValidDate(person, action) {
    while (true) {
        const date = window.prompt(`Enter ${action} date (dd/mm/yy, dd/mm/yyyy, d/m/yyyy or d/m/y):`);

        if (date === null) {
            return null;
        }

        const normalizedDate = normalizeDateString(date.trim());
        if (normalizedDate) {
            return normalizedDate;
        }

        await notifyInvalidPromptInput({
            action,
            field: 'date',
            value: date,
            email: person?.EMAIL,
        });
        alert('Please enter a valid date in one of these formats: dd/mm/yy, dd/mm/yyyy, d/m/yyyy, or d/m/y.');
    }
}

async function promptForUpgradeDetails(person) {
    const amount = await promptForValidAmount(person, 'upgrade');
    if (!amount) {
        return null;
    }

    const date = await promptForValidDate(person, 'upgrade');
    if (!date) {
        return null;
    }

    return { amount, date };
}

function getFormattedDateFromValue(value) {
    const fallbackDate = () => {
        const d = new Date();
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = String(d.getFullYear()).slice(-2);
        return `${day}/${month}/${year}`;
    };

    if (!value) {
        return fallbackDate();
    }

    if (typeof value === 'string') {
        const trimmed = value.trim();
        const normalizedDate = normalizeDateString(trimmed);
        if (normalizedDate) {
            return normalizedDate;
        }

        const parsedStringDate = new Date(trimmed);
        if (!Number.isNaN(parsedStringDate.getTime())) {
            value = parsedStringDate;
        }
    }

    if (value instanceof Date) {
        if (Number.isNaN(value.getTime())) {
            return fallbackDate();
        }
        const day = String(value.getDate()).padStart(2, '0');
        const month = String(value.getMonth() + 1).padStart(2, '0');
        const year = String(value.getFullYear()).slice(-2);
        return `${day}/${month}/${year}`;
    }

    if (typeof value === 'number') {
        const milliseconds = value < 1e12 ? value * 1000 : value;
        const parsedNumericDate = new Date(milliseconds);
        if (!Number.isNaN(parsedNumericDate.getTime())) {
            const day = String(parsedNumericDate.getDate()).padStart(2, '0');
            const month = String(parsedNumericDate.getMonth() + 1).padStart(2, '0');
            const year = String(parsedNumericDate.getFullYear()).slice(-2);
            return `${day}/${month}/${year}`;
        }
    }

    return fallbackDate();
}

function submitIncomeLog(person, amount, type, dateValue) {
    const normalizedAmount = normalizeAmountInput(amount);
    const data = {
        mode: 'manual',
        row: {
            DATE: getFormattedDateFromValue(dateValue),
            PERSON: `${person.firstname1 || ''} ${person.middlename1 || ''} ${person.lastname1 || ''}`.trim(),
            AMOUNT: normalizedAmount,
            TYPE: type,
            BUSINESS: person.country1?.trim() === 'Kenya' ? 'PENZIHALISI' : 'UH',
        },
    };

    return fetch('https://vmi2737685.contaboserver.net/api/income/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    })
        .then(() => true)
        .catch((err) => {
            console.error(`Error recording ${type?.toLowerCase()}:`, err)
            return false
        });
}

function recordUpgrade(person, amount, dateStr) {
    submitIncomeLog(person, amount, 'UPGRADE', dateStr);
}

function ManualUpgradeModal({ show, setShow, person }) {
    const [amount, setAmount] = React.useState('');
    const [date, setDate] = React.useState('');

    function submit() {
        const normalizedAmount = normalizeAmountInput(amount);
        if (normalizedAmount && date) {
            recordUpgrade(person, normalizedAmount, date);
            setAmount('');
            setDate('');
            setShow(false);
        } else {
            alert('Please enter an amount and date');
        }
    }

    return (
        <GeneralModal
            showModal={show}
            maintitle={`Record Upgrade`}
            canceltext="Close"
            notdisableproceed={false}
            setShowModal={setShow}
        >
            <div className="flex flex-col">
                <input
                    className="border border-gray-300 p-2 mb-2"
                    placeholder="Amount"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                />
                <input
                    className="border border-gray-300 p-2 mb-2"
                    placeholder="Date (dd/mm/yy)"
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                />
                <button
                    className="bg-red-800 text-white p-2 rounded-md"
                    onClick={submit}
                >
                    Submit
                </button>
            </div>
        </GeneralModal>
    );
}

function validateEmail(value) {
    if (value.includes(" ")) {
        return "Your email cannot contain spaces. Please remove the spaces and try again.";
    }
    if (/[A-Z]/.test(value)) {
        return "Your email cannot contain capital letters. Please use lowercase letters only.";
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) {
        return "Please enter a valid email address.";
    }
    return "";
}

function validatePassword(value) {
    if (value.length < 8) {
        return "Password must be at least 8 characters long.";
    }
    return "";
}

function fillerfunction () {
    // pretends to do something so form doesnt auto submit after option select
    console.log('Ayo')
}

function answerToText(value) {
    if (Array.isArray(value)) {
        return (value[0] || '').toString();
    }
    return (value || '').toString();
}

function nostrings(item) {
    if (Object.prototype.toString.call(item) !== '[object Array]') {
        return [item]
    } else {
        return item
    }
}

function formatFieldValue(value) {
    if (value === null || value === undefined) {
        return ''
    }

    if (typeof value === 'object') {
        try {
            return JSON.stringify(value, null, 2)
        } catch (err) {
            console.error('Failed to stringify field value', err)
            return ''
        }
    }

    return String(value)
}

function coerceFieldValue(originalValue, rawValue) {
    const trimmed = typeof rawValue === 'string' ? rawValue.trim() : rawValue

    if (typeof originalValue === 'number') {
        const parsed = Number(trimmed)
        return Number.isNaN(parsed) ? rawValue : parsed
    }

    if (typeof originalValue === 'boolean') {
        const lowered = String(trimmed).toLowerCase()
        if (lowered === 'true') return true
        if (lowered === 'false') return false
        return rawValue
    }

    if (originalValue !== null && typeof originalValue === 'object') {
        try {
            return JSON.parse(rawValue)
        } catch (err) {
            console.warn('Could not parse JSON value, falling back to string.', err)
            return rawValue
        }
    }

    if (originalValue === null || originalValue === undefined) {
        if (trimmed === '') {
            return ''
        }

        const lowered = String(trimmed).toLowerCase()
        if (lowered === 'true') return true
        if (lowered === 'false') return false

        const parsed = Number(trimmed)
        if (!Number.isNaN(parsed) && trimmed !== '') {
            return parsed
        }

        try {
            return JSON.parse(rawValue)
        } catch (err) {
            return rawValue
        }
    }

    return rawValue
}

function useProfileFieldEditor(profile, onSuccess) {
    const [showEditModal, setShowEditModal] = React.useState(false)
    const [selectedField, setSelectedField] = React.useState('')
    const [fieldValue, setFieldValue] = React.useState('')
    const [isSubmitting, setIsSubmitting] = React.useState(false)

    const editableFields = React.useMemo(() => {
        return Object.keys(profile || {}).filter((key) => key !== '__id')
    }, [profile])

    React.useEffect(() => {
        if (editableFields.length === 0) {
            if (selectedField !== '') setSelectedField('')
            setFieldValue('')
            return
        }

        if (!selectedField || !editableFields.includes(selectedField)) {
            setSelectedField(editableFields[0])
        }
    }, [editableFields, selectedField])

    React.useEffect(() => {
        if (!selectedField) {
            setFieldValue('')
            return
        }

        setFieldValue(formatFieldValue(profile?.[selectedField]))
    }, [profile, selectedField])

    const handleFieldChange = React.useCallback((event) => {
        setSelectedField(event.target.value)
    }, [])

    const handleValueChange = React.useCallback((event) => {
        setFieldValue(event.target.value)
    }, [])

    const openEditModal = React.useCallback(() => {
        if (editableFields.length === 0) {
            alert('No editable fields found for this profile.')
            return false
        }

        const fieldToUse = selectedField && editableFields.includes(selectedField)
            ? selectedField
            : editableFields[0]

        if (fieldToUse !== selectedField) {
            setSelectedField(fieldToUse)
        }
        setFieldValue(formatFieldValue(profile?.[fieldToUse]))
        setShowEditModal(true)
        return true
    }, [editableFields, profile, selectedField])

    const handleEditSubmit = React.useCallback((event) => {
        event.preventDefault()

        if (!selectedField) {
            alert('Please choose a field to edit.')
            return
        }

        const email = profile?.EMAIL
        if (!email) {
            alert('Missing email address for this profile. Cannot save changes.')
            return
        }

        if (typeof fieldValue === 'string' && fieldValue.trim() === '') {
            alert('Please enter a value before saving. Empty values are ignored by the server.')
            return
        }

        const originalValue = profile ? profile[selectedField] : undefined
        const newValue = coerceFieldValue(originalValue, fieldValue)

        setIsSubmitting(true)
        postData('/api/edit_data', {
            _lookup_EMAIL: email,
            _lookup_fullname1: profile?.fullname1 || '',
            EMAIL: email,
            [selectedField]: newValue,
        }).then((data) => {
            if (data?.responsecode === 200) {
                alert('Profile updated successfully.')
                if (typeof onSuccess === 'function') {
                    onSuccess()
                }
                setShowEditModal(false)
            } else {
                alert('Failed to update profile data.')
            }
        }).catch((error) => {
            console.error('Error updating profile data:', error)
            alert('Failed to update profile data.')
        }).finally(() => {
            setIsSubmitting(false)
        })
    }, [fieldValue, onSuccess, profile, selectedField])

    return {
        editableFields,
        fieldValue,
        handleEditSubmit,
        handleFieldChange,
        handleValueChange,
        isSubmitting,
        openEditModal,
        selectedField,
        setShowEditModal,
        showEditModal,
    }
}

function CoolOption(props) {
    const [selected, setSelected] = React.useState(props.alreadyselected || false)

    React.useEffect(() => {
        setSelected(props.alreadyselected || false)
    }, [props.alreadyselected])
    
    function onselection() {
        setSelected(true)
        
        if (props.text === "Other") {
            props.setSelectedOther(true)
            props.setField('', props.fieldid, "choice", props.pick, props.numberselected, props.setNumberSelected)
            props.setItemFilled(false)
        } else {
            props.setField(props.text, props.fieldid, "choice", props.pick, props.numberselected, props.setNumberSelected)
            props.setItemFilled(true)

            console.log("Number to pick: ", props.pick)
            console.log("Number selected: ", props.numberselected)

            setTimeout(function () {
                if (props.numberselected+1 >= props.pick) {
                    props.nextstep()
                }
            }, 200)
        }
    }

    function onDeselection () {
        setSelected(false)
        props.setField(props.text, props.fieldid, "choice", props.pick, props.numberselected, props.setNumberSelected)
        const newCount = props.numberselected - 1
        if (newCount <= 0) {
            props.setItemFilled(false)
        }
    }

    return (
        <div key={props.index} className='w-full'>
            {selected
                ? <button className="w-full p-2 mb-2 bg-primary text-white border-white league-spartan rounded-full" onClick={() => onDeselection()}>{props.text}</button>
                : <button className="w-full p-2 mb-2 bg-white border-white text-black league-spartan rounded-full font-bold" onClick={() => onselection()}>{props.text}</button>
            }
        </div>
    )
}

function FormQuestion(props) {
    function getDynamicAnswers() {
        const country = answerToText(props.answers['country1']).trim().toLowerCase();
        if (props.item.fieldid === 'brandpreferences1') {
            if (country === 'tanzania') return tanzaniaBrandPreferences;
            if (country === 'uganda') return ugandaBrandPreferences;
            return props.item.answers;
        }
        if (props.item.fieldid === 'residentialarea1') {
            if (country === 'tanzania') return tanzaniaResidentialAreas;
            if (country === 'uganda') return ugandaResidentialAreas;
            return props.item.answers;
        }
        if (props.item.fieldid === 'monthlyincome1') {
            if (country === 'tanzania') return tanzaniaMonthlyIncome;
            if (country === 'uganda') return ugandaMonthlyIncome;
            return props.item.answers;
        }
        if (props.item.fieldid === 'monthlyincomeaftertax1') {
            if (country === 'tanzania') return tanzaniaMonthlyIncomeAfterTax;
            if (country === 'uganda') return ugandaMonthlyIncomeAfterTax;
            return props.item.answers;
        }
        return props.item.answers;
    }

    function checkifanswerisntoftheoptions() {
        if (props.item.type === "choice") {
            const field = props.answers[props.item.fieldid]
            if (field) {
                const items = getDynamicAnswers()
                if (!items.includes(field)) {
                    return true
                } else {
                    return false
                }
            } else {
                return false
            }
        } else {
            return false
        }
    }

    function settofilledornot() {
        if (props.edit && props.answers && props.answers[props.item.fieldid]) {
            return true
        } else if (props.item.type === "image") {
            return true
        } else if (props.item.type === "captcha") {
            return true
        } else if (props.item.type === "choice") {
            const saved = props.answers[props.item.fieldid]
            if (saved && nostrings(saved).length > 0) {
                return true
            } else {
                return false
            }
        } else if (props.item.fieldid === 'heightinfeet1') {
            const saveddata = safeParse(getLocalStorageItem('formData'), 'formData')
            if (!saveddata) {
                return false
            } else {
                const feet = saveddata['heightinfeet1']
                const inches = saveddata['heightininches1']
                if (feet && inches) {
                    return true
                } else {
                    return false
                }
            }
        } else {
            const saveddata = safeParse(getLocalStorageItem('formData'), 'formData')
            if (!saveddata) {
                return false
            } else {
                const field = saveddata[props.item.fieldid]
                if (field && field.trim().toLowerCase() !== 'other') {
                    return true
                } else {
                    return false
                }
            }
        }
    }

    const recaptcha = props.recaptcha
    const [numberselected, setNumberSelected] = React.useState(
        nostrings(props.answers[props.item.fieldid] || []).length
    )
    const [rangeslider, setRangeSlider] = React.useState(props.answers[props.item.fieldid] || 18)
    const [rangeInches, setRangeInches] = React.useState(props.answers['heightininches1'] || 1)
    const [rangeMax, setRangeMax] = React.useState(props.answers['maxage1'] || 18)
    const [selectedother, setSelectedOther] = React.useState(checkifanswerisntoftheoptions())
    const [itemfilled, setItemFilled] = React.useState(settofilledornot())
    const pick = props.item.pick || 1

    React.useEffect(() => {
        if (props.answers['heightininches1']) setRangeInches(props.answers['heightininches1'])
    }, [props.answers['heightininches1']])

    React.useEffect(() => {
        if (props.answers['maxage1']) setRangeMax(props.answers['maxage1'])
    }, [props.answers['maxage1']])

    function checkfieldisntpresent(thefield, valuetocheck, valuecorrectimportant) {
        const field = props.answers[thefield]
        if (field) {
            const isvalue = field.includes(valuetocheck) 
            if (valuecorrectimportant) {
                return isvalue
            } else {
                return true
            }
        } else {
            return false
        }
    }

    function controlledupdate(value, fieldid) {
        props.setField(value, fieldid)
        if (fieldid === 'heightinfeet1' || fieldid === 'heightininches1') {
            const feet = fieldid === 'heightinfeet1' ? value : props.answers['heightinfeet1']
            const inches = fieldid === 'heightininches1' ? value : props.answers['heightininches1']
            if (feet && inches) {
                setItemFilled(true)
            }
        } else if (fieldid === 'minage1' || fieldid === 'maxage1') {
            const minVal = fieldid === 'minage1' ? value : props.answers['minage1']
            const maxVal = fieldid === 'maxage1' ? value : props.answers['maxage1']
            if (minVal && maxVal) {
                setItemFilled(true)
            }
        } else if (value) {
            if (value.trim().toLowerCase() === 'other') {
                setItemFilled(false)
            } else {
                setItemFilled(true)
            }
        }
    }

    function handleNumberInput(e, fieldid) {
        const original = e.target.value
        const value = original.replace(/\D/g, '')
        if (original !== value) {
            alert('Please enter numbers only for this step; letters are not allowed.')
        }
        controlledupdate(value, fieldid)
    }

    function gotonextstep() {
        if (itemfilled) {
            if (props.item.fieldid === 'EMAIL') {
                if (!(props.edit && props.gender === 'Male')) {
                    const msg = validateEmail(props.answers[props.item.fieldid] || '')
                    if (msg) { alert(msg); return; }
                }
            }
            if (props.item.fieldid === 'password') {
                const msg = validatePassword(props.answers[props.item.fieldid] || '')
                if (msg) { alert(msg); return; }
            }
            if (props.item.fieldid === 'phonenumber1' && (props.answers[props.item.fieldid] || '').length < 10) {
                alert('Phone number must be at least 10 characters long.');
                return;
            }
            if (props.item.fieldid === 'currentoccupation1' && (props.answers[props.item.fieldid] || '').length < 5) {
                alert('Occupation must be at least 5 characters long.');
                return;
            }
            props.ForwardStep()
        } else {
            alert(`You have not answered the question: ${props.item.question}. Please do.`)
        }
    }

    function renderAccQuestion() {
        if (props.item.type === "choice") {
            return (
                <>
                {props.men
                    ? <>
                        {props.item.sectionshow
                            ? <p className="text-white text-xl mt-1 text-center">{props.item.section}</p>
                            : null
                        }
                        <p className="text-white text-base mb-2 text-center">{props.item.question}</p>
                      </>
                    : <>
                        <p className="text-white text-xl mt-1 text-center">{props.item.section}</p>
                        <p className="text-white text-base mb-2 text-center">{props.item.question}</p>
                      </>
                }
                
                {props.laststep
                    ? <>
                        {getDynamicAnswers().map((item, index) => (
                            <CoolOption key={index}
                                index={index}
                                text={item} setField={props.setField}
                                fieldid={props.item.fieldid} pick={pick} setItemFilled={setItemFilled}
                                numberselected={numberselected} setNumberSelected={setNumberSelected}
                                nextstep={fillerfunction} setSelectedOther={setSelectedOther}
                                alreadyselected={checkfieldisntpresent(props.item.fieldid, item, true)}/>
                        ))}
                      </>
                    : <>
                        {getDynamicAnswers().map((item, index) => (
                            <CoolOption key={index}
                                index={index}
                                text={item} setField={props.setField}
                                fieldid={props.item.fieldid} pick={pick} setItemFilled={setItemFilled}
                                numberselected={numberselected} setNumberSelected={setNumberSelected}
                                nextstep={props.ForwardStep} setSelectedOther={setSelectedOther}
                                alreadyselected={checkfieldisntpresent(props.item.fieldid, item, true)}/>
                        ))}
                      </>
                }

                {selectedother
                    ? <>
                        {checkifanswerisntoftheoptions()
                            ? <input className="bg-white text-black placeholder-gray-600 p-4 my-2 rounded-none text-lg" defaultValue={props.answers[props.item.fieldid]} placeholder={'Please expand:'} onChange={(e) => controlledupdate(e.target.value, props.item.fieldid)}/>
                            : <input className="bg-white text-black placeholder-gray-600 p-4 my-2 rounded-none text-lg" placeholder={'Please expand:'} onChange={(e) => controlledupdate(e.target.value, props.item.fieldid)}/>
                        }
                      </>
                    : null
                }
                
                {!props.firststep && !viewportFit
                    ? <>
                        {props.men ? null 
                            : <div className="signup-question-navigation grid grid-cols-2 mt-3 gap-2 w-full">
                                <button onClick={() => props.MinusStep()} className="w-full text-white bg-primary p-2 rounded-full">Prev</button>
                                <button onClick={() => gotonextstep()} className="w-full text-white bg-primary p-2 rounded-full">Next</button>
                              </div>
                        }
                      </>
                    : null
                }
                </>
            )
        } else if (props.item.type === "age") {
            const min = props.item.min || 1
            const max = props.item.max || 150
            if (props.item.fieldid === 'heightinfeet1') {
                const minInches = 1
                const maxInches = 11
                return (
                    <>
                    {props.item.sectionshow
                        ? <p className="text-white text-xl mt-1">{props.item.section}</p>
                        : null
                    }
                    {props.men ? null
                        : <p className="text-white text-xl mt-1">{props.item.section}</p>
                    }
                    <label htmlFor="steps-range" className="block mb-2 text-sm font-medium text-gray-100 dark:text-white">Height (Feet): {rangeslider}</label>
                    <input type="range" min={min} max={max} step="1" className="w-full h-2 bg-yellow-400 accent-pink-600 mt-1 mb-3 rounded-lg appearance-none cursor-pointer" value={rangeslider} onChange={(e) => {setRangeSlider(e.target.value);controlledupdate(e.target.value, 'heightinfeet1')}}/>
                    <label htmlFor="steps-range-2" className="block mb-2 text-sm font-medium text-gray-100 dark:text-white">Height (Inches): {rangeInches}</label>
                    <input type="range" min={minInches} max={maxInches} step="1" className="w-full h-2 bg-yellow-400 accent-pink-600 mt-1 mb-3 rounded-lg appearance-none cursor-pointer" value={rangeInches} onChange={(e) => {setRangeInches(e.target.value);controlledupdate(e.target.value, 'heightininches1')}}/>
                    </>
                )
            } else if (props.item.fieldid === 'heightininches1') {
                return null
            } else if (props.item.fieldid === 'minage1') {
                return (
                    <>
                    {props.item.sectionshow
                        ? <p className="text-white text-xl mt-1">{props.item.section}</p>
                        : null
                    }
                    {props.men ? null
                        : <p className="text-white text-xl mt-1">{props.item.section}</p>
                    }
                    <label htmlFor="steps-range" className="block mb-2 text-sm font-medium text-gray-100 dark:text-white">Minimum Age: {rangeslider}</label>
                    <input type="range" min={min} max={max} step="1" className="w-full h-2 bg-yellow-400 accent-pink-600 mt-1 mb-3 rounded-lg appearance-none cursor-pointer" value={rangeslider} onChange={(e) => {setRangeSlider(e.target.value);controlledupdate(e.target.value, 'minage1')}}/>
                    <label htmlFor="steps-range-max" className="block mb-2 text-sm font-medium text-gray-100 dark:text-white">Maximum Age: {rangeMax}</label>
                    <input type="range" min={min} max={max} step="1" className="w-full h-2 bg-yellow-400 accent-pink-600 mt-1 mb-3 rounded-lg appearance-none cursor-pointer" value={rangeMax} onChange={(e) => {setRangeMax(e.target.value);controlledupdate(e.target.value, 'maxage1')}}/>
                    </>
                )
            } else {
                return (
                    <>
                    {props.item.sectionshow
                        ? <p className="text-white text-xl mt-1">{props.item.section}</p>
                        : null
                    }
                    {props.men ? null
                        : <p className="text-white text-xl mt-1">{props.item.section}</p>
                    }
                    <label htmlFor="steps-range" className="block mb-2 text-sm font-medium text-gray-100 dark:text-white">{props.item.question}: {rangeslider}</label>
                    <input type="range" min={min} max={max} step="1" className="w-full h-2 bg-yellow-400 accent-pink-600 mt-1 mb-3 rounded-lg appearance-none cursor-pointer" value={rangeslider} onChange={(e) => {setRangeSlider(e.target.value);controlledupdate(e.target.value, props.item.fieldid)}}/>
                    </>
                )
            }
        } else if (props.item.type === "pass") {
            return (
                <>
                    {props.men
                        ? <>
                            {props.item.sectionshow
                                ? <p className="text-white text-xl mt-1">{props.item.section}</p>
                                : null
                            }
                            <PasswordInput setValue={(val) => controlledupdate(val, props.item.fieldid)} />
                          </>
                        : <>
                            <p className="text-white text-xl">{props.item.section}</p>
                            <p className="text-white text-base">{props.item.question}</p>
                            <PasswordInput setValue={(val) => controlledupdate(val, props.item.fieldid)} />
                          </>
                    }
                </>
            )
        } else if (props.item.type === "longtext") {
            return (
                <>
                    {props.men
                        ? <>
                            {props.item.sectionshow
                                ? <p className="text-white text-xl mt-1">{props.item.section}</p>
                                : null
                            }
                            {props.item.fieldid === 'futurespouse1'
                                ? <MDEditor value={props.answers[props.item.fieldid] || ''} onChange={(val) => controlledupdate(val, props.item.fieldid)} preview="edit" data-color-mode="light" className="signup-spouse-editor w-full normal-case" />
                                : <textarea className="bg-white text-black placeholder-gray-600 p-2 my-2 w-full h-64" placeholder={props.item.question+':'} defaultValue={props.answers[props.item.fieldid] || ''} onChange={(e) => controlledupdate(e.target.value, props.item.fieldid)}/>
                            }
                          </>
                        : <>
                            <p className="text-white text-xl">{props.item.section}</p>
                            <p className="text-white text-base">{props.item.question}</p>
                            {props.item.fieldid === 'futurespouse1'
                                ? <MDEditor value={props.answers[props.item.fieldid] || ''} onChange={(val) => controlledupdate(val, props.item.fieldid)} preview="edit" data-color-mode="light" className="signup-spouse-editor w-full normal-case" />
                                : <textarea className="bg-white text-black placeholder-gray-600 p-2 w-full h-64" placeholder='Enter Text:' defaultValue={props.answers[props.item.fieldid] || ''} onChange={(e) => controlledupdate(e.target.value, props.item.fieldid)}/>
                            }
                          </>
                    }
                </>
            )
        } else if (props.item.type === "image") {
            const fullname1 = props.answers.fullname1
            const EMAIL = props.answers.EMAIL
            const therandomUUID = generateUUID()
            console.log("Current State of things at image form component show.");
            console.log("Email:", EMAIL);
            console.log("Full name:", fullname1);
            console.log("ID:", therandomUUID);
            
            return (
                <>
                    {props.men
                        ? <>
                            {props.item.sectionshow
                                ? <p className="text-white text-xl mt-1">{props.item.section}</p>
                                : null
                            }
                            <p className="text-white text-base mt-1">{props.item.question}</p>
                            <ImageFormComponent EMAIL={EMAIL} id={therandomUUID} fullname1={fullname1} allanswers={props.answers} gender={props.gender}/>
                          </>
                        : <>
                            <p className="text-white text-xl">{props.item.section}</p>
                            <p className="text-white text-base">{props.item.question}</p>
                            <ImageFormComponent EMAIL={EMAIL} id={therandomUUID} fullname1={fullname1} allanswers={props.answers} gender={props.gender}/>
                          </>
                    }
                </>
            )
        } else if (props.item.type === "captcha") {
            return (
                <>
                    <p className="text-white text-base mt-1">{props.item.question}</p>
                    <ReCAPTCHA ref={recaptcha} sitekey={"6LfTO2YqAAAAAEJnKMWW2zz_wK972wr7z4yZEVSh"} />
                </>
            )
        } else if (props.item.type === "datalistinput") {
            return (
                <>
                    {props.men
                        ? <>
                            {props.item.sectionshow
                                ? <p className="text-white text-xl mt-1">{props.item.section}</p>
                                : null
                            }
                            
                            <DatalistInput 
                                id={props.item.fieldid} 
                                placeholder={props.item.question+':'}
                                onChange={function(text) {props.setField(text, props.item.fieldid)}}
                                options={props.item.answers}
                            />
                          </>
                        : <>
                            <p className="text-white text-xl">{props.item.section}</p>
                            <p className="text-white text-base">{props.item.question}</p>
                            <input className="bg-white text-black placeholder-gray-600 p-4 rounded-full text-lg" placeholder='Enter Text:' defaultValue={props.answers[props.item.fieldid] || ""} onChange={(e) => {
                                if (props.item.fieldid === 'phonenumber1' || props.item.fieldid === 'phonenumbercountrycode1' || props.item.fieldid === 'age1') {
                                    handleNumberInput(e, props.item.fieldid)
                                } else {
                                    controlledupdate(e.target.value, props.item.fieldid)
                                }
                            }}/>
                          </>
                    }
                </>
            )
        } else {
            return (
                <>
                    {props.men
                        ? <>
                            {props.item.sectionshow
                                ? <p className="text-white text-xl mt-1">{props.item.section}</p>
                                : null
                            }
                            <input className="bg-white text-black placeholder-gray-600 p-4 my-2 w-full text-lg" placeholder={props.item.question+':'} defaultValue={props.answers[props.item.fieldid] || ""} onChange={(e) => {
                                if (props.item.fieldid === 'phonenumber1' || props.item.fieldid === 'phonenumbercountrycode1' || props.item.fieldid === 'age1') {
                                    handleNumberInput(e, props.item.fieldid)
                                } else {
                                    controlledupdate(e.target.value, props.item.fieldid)
                                }
                            }}/>
                          </>
                        : <>
                            <p className="text-white text-xl">{props.item.section}</p>
                            <p className="text-white text-base">{props.item.question}</p>
                            <input className="bg-white text-black placeholder-gray-600 p-4 w-full text-lg" placeholder='Enter Text:' defaultValue={props.answers[props.item.fieldid] || ""} onChange={(e) => {
                                if (props.item.fieldid === 'phonenumber1' || props.item.fieldid === 'phonenumbercountrycode1' || props.item.fieldid === 'age1') {
                                    handleNumberInput(e, props.item.fieldid)
                                } else {
                                    controlledupdate(e.target.value, props.item.fieldid)
                                }
                            }}/>
                          </>
                    }
                </>
            )
        }
    }
    
    const viewportFit = props.rendersequentially && !props.edit && !props.men;
    return (
        <div key={props.index} className={viewportFit ? 'signup-question-slot' : undefined}>
            {props.showitem
                ? <motion.div
                    className="signup-question-frame flex flex-col items-center justify-center bg-black bg-opacity-75 p-4 rounded-md w-11/12 md:w-5/6 lg:w-2/3 mx-auto"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{duration:1}}
                >
                    {viewportFit ? <>
                        <header className="signup-question-heading">
                            <p>{props.item.section}</p>
                            <h2>{props.item.question}</h2>
                        </header>
                        <div className="signup-question-answers" key={props.item.fieldid}>{renderAccQuestion()}</div>
                        <nav className="signup-question-actions" aria-label="Question navigation">
                            {!props.firststep && <button type="button" onClick={() => props.MinusStep()} className="w-full text-white bg-primary p-2 rounded-full">Prev</button>}
                            <button type="button" onClick={() => gotonextstep()} className="w-full text-white bg-primary p-2 rounded-full">Next</button>
                        </nav>
                    </> : renderAccQuestion()}
                    
                    {props.rendersequentially && !viewportFit
                        ? <>
                            {props.firststep
                                ? <button onClick={() => gotonextstep()} className="w-full text-white bg-primary p-2 rounded-full mt-3">Next</button>
                                : <>
                                    {props.item.type !== "choice"
                                        ? <div className="signup-question-navigation grid grid-cols-2 mt-3 gap-2 w-full">
                                            <button onClick={() => props.MinusStep()} className="w-full text-white bg-primary p-2 rounded-full">Prev</button>
                                            <button onClick={() => gotonextstep()} className="w-full text-white bg-primary p-2 rounded-full">Next</button>
                                            </div>
                                            : null
                                    }
                                </>
                            }
                        </>
                        : null
                    }

                    {props.rendersequentially
                        ? null
                        : <>
                            {props.laststep
                                ? <button onClick={() => gotonextstep()} className="w-full text-white bg-primary p-2 rounded-full mt-3">Submit</button>
                                : null
                            }
                        </>
                    }
                    
                </motion.div>
                : null
            }
        </div>
    )
}

function ReviewStep({ questions, answers, gotoStep, onSubmit, setField, submitLabel = 'Submit' }) {
    const [viewImage, setViewImage] = React.useState(null)
    const [editingIndex, setEditingIndex] = React.useState(null)
    const [imageVersion, setImageVersion] = React.useState(0)

    function getDynamicAnswersForItem(it) {
        const country = answerToText(answers['country1']).trim().toLowerCase();
        if (it.fieldid === 'brandpreferences1') {
            if (country === 'tanzania') return tanzaniaBrandPreferences;
            if (country === 'uganda') return ugandaBrandPreferences;
            return it.answers;
        }
        if (it.fieldid === 'residentialarea1') {
            if (country === 'tanzania') return tanzaniaResidentialAreas;
            if (country === 'uganda') return ugandaResidentialAreas;
            return it.answers;
        }
        if (it.fieldid === 'monthlyincome1') {
            if (country === 'tanzania') return tanzaniaMonthlyIncome;
            if (country === 'uganda') return ugandaMonthlyIncome;
            return it.answers;
        }
        if (it.fieldid === 'monthlyincomeaftertax1') {
            if (country === 'tanzania') return tanzaniaMonthlyIncomeAfterTax;
            if (country === 'uganda') return ugandaMonthlyIncomeAfterTax;
            return it.answers;
        }
        return it.answers;
    }

    function renderAnswer(item) {
        if (item.type === 'image') {
            const match = /profilepic(\d+)/.exec(item.fieldid || '')
            const imgNum = match ? match[1] : '1'
            const identifier = answers.EMAIL || answers.fullname1 || ''
            const src = `/api/profilepic/${imgNum}?EMAIL=${identifier}&v=${imageVersion}`
            return (
                <img className="w-1/4 h-auto mb-2 cursor-pointer" src={src} alt={item.question} onClick={() => setViewImage(src)} />
            )
        }
        return (
            <p className="text-white text-xs">{Array.isArray(answers[item.fieldid]) ? answers[item.fieldid].join(', ') : answers[item.fieldid]}</p>
        )
    }

    function renderEditInput(item) {
        if (item.type === 'choice') {
            const pick = item.pick || 1
            const current = Array.isArray(answers[item.fieldid]) ? answers[item.fieldid] : []
            return (
                <div>
                    {getDynamicAnswersForItem(item).map((opt, i) => (
                        <label key={i} className="block text-black">
                            <input
                                type={pick === 1 ? 'radio' : 'checkbox'}
                                className="mr-2"
                                name={item.fieldid}
                                value={opt}
                                checked={current.includes(opt)}
                                onChange={() => setField(opt, item.fieldid, 'choice', pick)}
                            />
                            {opt}
                        </label>
                    ))}
                </div>
            )
        } else if (item.type === 'longtext') {
            return (
                <textarea
                    className="border p-2 w-full"
                    defaultValue={answers[item.fieldid] || ''}
                    onChange={(e) => setField(e.target.value, item.fieldid)}
                />
            )
        } else if (item.type === 'pass') {
            return (
                <input
                    type="password"
                    className="border p-2 w-full"
                    defaultValue={answers[item.fieldid] || ''}
                    onChange={(e) => setField(e.target.value, item.fieldid)}
                />
            )
        } else if (item.type === 'age') {
            const min = item.min || 1
            const max = item.max || 100
            return (
                <input
                    type="range"
                    min={min}
                    max={max}
                    className="w-full"
                    value={answers[item.fieldid] || min}
                    onChange={(e) => setField(e.target.value, item.fieldid)}
                />
            )
        } else if (item.type === 'image') {
            const fullname1 = answers.fullname1
            const EMAIL = answers.EMAIL
            return (
                <ImageFormComponent
                    EMAIL={EMAIL}
                    id={item.fieldid}
                    fullname1={fullname1}
                    allanswers={answers}
                    nextstep={() => { setImageVersion(v => v + 1); setEditingIndex(null); }}
                />
            )
        }
        return (
            <input
                type="text"
                className="border p-2 w-full"
                defaultValue={answers[item.fieldid] || ''}
                onChange={(e) => setField(e.target.value, item.fieldid)}
            />
        )
    }

    return (
        <div className="signup-review-frame flex flex-col items-center justify-center bg-black bg-opacity-75 p-4 rounded-md w-11/12 md:w-5/6 lg:w-2/3 mx-auto">
            <p className="text-white text-xl mb-2">Review Your Answers</p>
            <div className="overflow-y-auto max-h-96 w-full">
                {questions.map((item, idx) => (
                    <div key={idx} className="mb-2 border-b border-white pb-1">
                        <p className="text-white text-sm">{item.question}</p>
                        {renderAnswer(item)}
                        <button onClick={() => setEditingIndex(idx)} className="bg-white text-black rounded-md text-xs px-2 py-1 mt-1">Edit</button>
                    </div>
                ))}
            </div>
            <button onClick={onSubmit} className="w-full text-white bg-primary p-2 rounded-full mt-3">{submitLabel}</button>
            <button onClick={() => gotoStep(questions.length - 1)} className="w-full text-black bg-white p-2 rounded-full mt-2">Back</button>
            {viewImage && (
                <GeneralModal showModal={true} maintitle="Image Preview" canceltext="Close" notdisableproceed={false} setShowModal={() => setViewImage(null)}>
                    <SmartImageComponent src={viewImage} id="Preview" cssclasses="max-h-[80vh] w-auto mx-auto" />
                </GeneralModal>
            )}
            {editingIndex !== null && (
                <GeneralModal
                    showModal={true}
                    maintitle={`Edit ${questions[editingIndex].question}`}
                    canceltext="Close"
                    notdisableproceed={false}
                    setShowModal={() => setEditingIndex(null)}
                >
                    {renderEditInput(questions[editingIndex])}
                </GeneralModal>
            )}
        </div>
    )
}

function fillornot(props) {
    if (props.og_data) {
        return props.og_data
    } else {
        if (props.mensform) {
            return fillerprofiledata()
        } else {
            return fillerprofiledata("Female")
        }
    }
}

export default function Signup(props) {
    const recaptcha = React.useRef()
    const captchapresent = props.captchapresent || false

    const [allanswers, setAllAnswers] = React.useState(fillornot(props))
    const [currentstep, setCurrentStep] = React.useState(0)
    const [submitting, setSubmitting] = React.useState(false)
    const submissionPending = React.useRef(false)
    const viewportRoot = React.useRef(null)
    const fitSignupViewport = !props.edit && !props.mensform

    useEffect(() => {
        if (!fitSignupViewport || !viewportRoot.current) return
        const root = viewportRoot.current
        const viewport = window.visualViewport
        const syncViewport = () => {
            root.style.setProperty('--signup-viewport-height', `${viewport ? viewport.height : window.innerHeight}px`)
            root.style.setProperty('--signup-viewport-top', `${viewport ? viewport.offsetTop : 0}px`)
        }
        syncViewport()
        window.addEventListener('resize', syncViewport)
        viewport?.addEventListener('resize', syncViewport)
        viewport?.addEventListener('scroll', syncViewport)
        return () => {
            window.removeEventListener('resize', syncViewport)
            viewport?.removeEventListener('resize', syncViewport)
            viewport?.removeEventListener('scroll', syncViewport)
        }
    }, [fitSignupViewport])

    const heightInchesIndex = props.allquestions.findIndex(q => q.fieldid === 'heightininches1')
    const displayQuestions = props.allquestions.filter((_, idx) => idx !== heightInchesIndex)
    const formQuestions = displayQuestions

    const numberofsteps = formQuestions.length
    const reviewIndex = numberofsteps
    const finalStepIndex = reviewIndex
    const childrenIndex = formQuestions.findIndex(q => q.fieldid === 'children1')
    const howManyChildrenIndex = formQuestions.findIndex(q => q.fieldid === 'howmanychildren2')
    const firstImageIndex = formQuestions.findIndex(q => q.type === 'image')
    const partnerProfileIndex = formQuestions.findIndex(q => q.fieldid === 'partnerqualitiesdetail1')
    let navigate = useNavigate();
    const signupHostname = (typeof window !== 'undefined' && window.location && window.location.hostname) ? window.location.hostname : "";
    const isUpendoHalisiSignup = /(^|\.)upendo-halisi\.com$/i.test(signupHostname);
    const isPenziHalisiSignup = signupHostname.includes("penzi-halisi.com");
    const isHalisiSignup = !props.edit && !props.mensform && (isUpendoHalisiSignup || isPenziHalisiSignup);
    const signupTheme = isUpendoHalisiSignup
        ? {
            key: 'uh',
            name: 'Upendo Halisi',
            kicker: 'Meet someone worth knowing',
            logo: '/assets/img/uhlogo.jpeg',
            title: 'Begin with intention.',
            subtitle: 'A private application for serious-minded singles seeking meaningful introductions.',
            accent: 'Warm · personal · sincere',
            note: 'Your answers help us understand who you are and who you hope to meet.',
        }
        : {
            key: 'ph',
            name: 'Penzi Halisi',
            kicker: 'Genuine connections',
            logo: '/assets/img/phlogo.jpeg',
            title: 'Apply for Penzi Halisi.',
            subtitle: 'A relationship-focused sign-up path designed for verified, referral-led introductions.',
            accent: 'Verified · focused · genuine',
            note: 'Complete each step carefully so we can prepare a sincere profile for matching.',
        };

    useEffect(() => {
        if (!props.edit && !props.mensform) captureAttribution();
        trackEvent(props.mensform ? 'admin_male_signup_started' : (props.edit ? 'profile_edit_form_started' : 'signup_form_started'));
    }, []);

    function gotoStep(step) {
        trackEvent(props.mensform ? 'admin_male_signup_step_viewed' : 'signup_step_viewed', { step });
        setCurrentStep(step);
        setLocalStorageItem('currentstep', JSON.stringify(step));
    }

    useEffect(() => {
        if (isHalisiSignup) {
            document.body.style.backgroundImage = '';
            document.body.style.backgroundSize = '';
            document.body.style.backgroundRepeat = '';
            document.body.style.backgroundPosition = '';
        } else {
            document.body.style.backgroundImage = "url('/assets/media/FORMBACKGROUND.jpeg')";
            document.body.style.backgroundSize = 'cover';
            document.body.style.backgroundRepeat = 'no-repeat';
            document.body.style.backgroundPosition = 'center';
        }
        return () => {
            document.body.style.backgroundImage = '';
            document.body.style.backgroundSize = '';
            document.body.style.backgroundRepeat = '';
            document.body.style.backgroundPosition = '';
        };
    }, [isHalisiSignup]);
    
    function ForwardStep() {
        trackEvent(props.mensform ? 'admin_male_signup_step_next_clicked' : 'signup_step_next_clicked', { step: currentstep });
        // 13 country
        console.log("Thew current step:", currentstep)
        let increment = 1
        if (currentstep === childrenIndex) {
            console.log("We have arrived at the skipping point")
            console.log("The value of the kids var: ", allanswers['children1'])
            if (allanswers['children1'] && allanswers['children1'][0] === "No") {
                const storenextstep = currentstep + 2
                setCurrentStep(storenextstep)
                increment = 2
            } else {
                const storenextstep = currentstep + 1
                setCurrentStep(storenextstep)
            }
        } else {
            const storenextstep = currentstep + 1
            setCurrentStep(storenextstep)
        }
        const savedstep = safeParse(getLocalStorageItem('currentstep'), 'currentstep');
        setLocalStorageItem('currentstep', JSON.stringify((savedstep || 0) + increment));
    }

    function MinusStep() {
        trackEvent(props.mensform ? 'admin_male_signup_step_prev_clicked' : 'signup_step_prev_clicked', { step: currentstep });
        let decrement = 1
        if (currentstep === howManyChildrenIndex + 1 && allanswers['children1'] && allanswers['children1'][0] === 'No') {
            decrement = 2
        }
        const storenextstep = currentstep - decrement
        setCurrentStep(storenextstep)
        setLocalStorageItem('currentstep', JSON.stringify(storenextstep))
    }

    function setField(value, field, type, picknumber, numberselected, setNumberSelected) {
        trackEvent(props.mensform ? 'admin_male_signup_question_answered' : 'signup_question_answered', { field });
        setAllAnswers(prev => {
            const currentanswers = { ...prev };
            console.log("Newthing ", currentanswers);
            if (field === "EMAIL" || field === "password") {
                currentanswers[field] = value
            } else if (type !== 'choice') {
                currentanswers[field] = value
            } else {
                if (!currentanswers[field]) {
                    currentanswers[field] = [value]
                    if (setNumberSelected) setNumberSelected(1)
                } else {
                    const currentanswerstoquestion = currentanswers[field]
                    let currentlypresent = nostrings(currentanswerstoquestion) || []

                    if (currentlypresent.includes(value)) {
                        currentlypresent = currentlypresent.filter(item => item !== value)
                    } else {
                        if (picknumber === 1) {
                            currentlypresent = [value]
                        } else if (!picknumber || currentlypresent.length < picknumber) {
                            currentlypresent.push(value)
                        }
                    }
                    currentanswers[field] = currentlypresent
                    if (setNumberSelected) setNumberSelected(currentanswers[field].length)
                }
            }
            if (!props.edit) {
                setLocalStorageItem('formData', JSON.stringify(currentanswers));
            }
            return currentanswers;
        })
    }

    function checkcaptcha() {
        if (captchapresent) {
            const captchaValue = recaptcha.current.getValue()
            return captchaValue
        } else {
            return true
        }
    }

    function handleSubmit(event) {
        if (event) event.preventDefault()
        if (submissionPending.current) return

        const captchaValue = checkcaptcha()
        trackEvent(props.mensform ? 'admin_male_signup_submit_pressed' : (props.edit ? 'profile_edit_submit_pressed' : 'signup_submit_pressed'))
        if (!captchaValue) {
            trackEvent('signup_captcha_failed')
            alert('Please verify the reCAPTCHA!')
        } else {
            // make form submission
            const url = props.url;
            const formData = new FormData();
            var currentanswers = { ...allanswers }
            // Old public-signup drafts may still contain the retired recording step.
            if (!props.edit && !props.mensform) {
                Object.keys(currentanswers).forEach(key => {
                    if (/^liveness/i.test(key)) delete currentanswers[key]
                })
            }
            if (currentanswers['EMAIL']) {
                currentanswers['EMAIL'] = currentanswers['EMAIL'].toString().trim().toLowerCase()
            }
            if (!(props.edit && props.gender === 'Male')) {
                const emailMsg = validateEmail(currentanswers['EMAIL'] || '')
                if (emailMsg) { trackEvent('signup_email_invalid'); alert(emailMsg); return }
            }
            const passMsg = validatePassword(currentanswers['password'] || '')
            if (passMsg) { trackEvent('signup_password_invalid'); alert(passMsg); return }
            if (!currentanswers['fullname1']) {
                currentanswers['fullname1'] = [
                    currentanswers['firstname1'],
                    currentanswers['middlename1'],
                    currentanswers['lastname1'],
                ].filter(Boolean).join(' ')
            }
            if (!props.edit && !props.mensform) {
                currentanswers['bridge_visitor_id'] = getOrCreateVisitorId()
                Object.assign(currentanswers, captureAttribution())
            }
            for (var key in currentanswers) {
                formData.append(key, currentanswers[key]) 
            }
            
            const config = {
                headers: {
                    'content-type': 'multipart/form-data',
                },
            };
            
            submissionPending.current = true
            setSubmitting(true)
            console.log(formData)
            postData(url, formData, config).then((data) => {
                console.log(data);
                if (data.responsecode === 200) {
                    const successEvent = props.mensform ? 'admin_male_signup_success' : (props.edit ? 'profile_edit_success' : 'signup_submit_success')
                    trackEvent(successEvent, currentanswers['EMAIL'] ? { user: currentanswers['EMAIL'], visitor_id: currentanswers['bridge_visitor_id'] } : {})
                    if (props.edit === true) {
                        setTimeout(function () {
                            navigate('/editssuccessful')
                        }, 2000)
                    } else {
                        if (props.mensform !== true) {
                            navigate('/registrationsuccess')
                        } else {
                            window.location.reload()
                        }
                    }
                } else {
                    trackEvent(props.mensform ? 'admin_male_signup_failed' : (props.edit ? 'profile_edit_failed' : 'signup_submit_failed'))
                    alert(data.message || "Something went wrong. Please contact support.")
                }
            }).catch((err) => {
                console.log("Error in setProfiledataSubmit: ", err);
                alert('Your signup could not be saved. Please try again.');
            }).finally(() => {
                submissionPending.current = false
                setSubmitting(false)
            });
        }

    }

    useEffect(() => {
        if (props.edit) {
            return
        }
        const saved = safeParse(getLocalStorageItem('formData'), 'formData') || null;
        if (saved) {
            trackEvent('signup_localstorage_restore_used')
            setAllAnswers(saved);
        } else {
            removeLocalStorageItem('currentstep')
        }
        const savedstep = safeParse(getLocalStorageItem('currentstep'), 'currentstep');
        if (Number.isInteger(savedstep) && savedstep >= 0) {
            const resumedStep = Math.min(savedstep, reviewIndex)
            setCurrentStep(resumedStep)
            setLocalStorageItem('currentstep', JSON.stringify(resumedStep))
        }
    }, []);

    useEffect(() => {
        if (!props.edit && currentstep === firstImageIndex) {
            alert("Please note that if you haven't uploaded your profile picture at the end of filling the form, you need to send it to the Whatsapp customer support so your account can be properly activated. Please do this immediately after finishing filling the form. Thank you for your understanding.")
        }
    }, [currentstep, firstImageIndex, props.edit]);

    useEffect(() => {
        if (!props.edit && partnerProfileIndex !== -1 && currentstep === partnerProfileIndex) {
            alert("To match you with the right partner, we need to understand the kind of man you’re drawn to and the type of relationship you want to build. Your answers help us create a profile that speaks directly to men who fit your emotional needs, values, and long-term vision.")
        }
    }, [currentstep, partnerProfileIndex, props.edit]);

    function renderSignupCompletion() {
        if (currentstep === reviewIndex) return <ReviewStep questions={displayQuestions} answers={allanswers} gotoStep={gotoStep} onSubmit={handleSubmit} setField={setField} submitLabel="Submit" />
        return null
    }

    if (props.mensform) {
        return (
            <div className="league-spartan mb-3 min-h-screen flex flex-col items-center justify-center md:justify-start">
                {formQuestions.map(function(item, index) {
                    if (index === numberofsteps-1) {
                        return (
                            <FormQuestion
                                index={index}
                                key={index}
                                item={item}
                                men={true}
                                ForwardStep={handleSubmit}
                                MinusStep={MinusStep}
                                setField={setField}
                                laststep={true}
                                firststep={(index===0)}
                                showitem={true}
                                rendersequentially={false}
                                answers={allanswers}
                                gender={props.gender}
                                edit={props.edit}
                                recaptcha={recaptcha}
                                allrequired={props.allrequired}
                            />
                        )
                    } else {
                        return (
                            <>
                                <FormQuestion
                                    index={index}
                                    key={index}
                                    item={item}
                                    men={true}
                                    ForwardStep={ForwardStep}
                                    MinusStep={MinusStep}
                                    laststep={false}
                                    setField={setField}
                                    firststep={(index===0)}
                                    showitem={true}
                                    rendersequentially={false}
                                    answers={allanswers}
                                    gender={props.gender}
                                    edit={props.edit}
                                    allrequired={props.allrequired}
                                    recaptcha={recaptcha}
                                />
                            </>
                        )
                    }
                })}
            </div>
        )
    } else {
        if (isHalisiSignup) {
            return (
                <div ref={viewportRoot} className={`halisi-signup-page ${signupTheme.key}-signup-page signup-viewport-page`}>
                    <style>{`
                        .halisi-signup-page{--navy:#041535;--navy-2:#082b68;--gold:#e3b94d;--gold-2:#ffd978;--ivory:#fffaf0;--ink:#0d2146;--pink:#ff58cf;--pink-2:#ff89dd;--line:rgba(211,166,53,.28);position:fixed;inset:0;z-index:20;min-height:100vh;overflow:auto;overflow-x:hidden;text-transform:none;font-family:Inter,ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;color:var(--ink);background:radial-gradient(circle at 20% 4%,rgba(35,91,177,.52),transparent 25%),radial-gradient(circle at 92% 14%,rgba(223,176,56,.12),transparent 20%),linear-gradient(145deg,#03122d 0%,#082a66 47%,#020d21 100%)}
                        .uh-signup-page{--line:rgba(216,180,90,.24);color:#fff;background:radial-gradient(circle at 50% -10%,rgba(255,88,207,.13),transparent 28%),radial-gradient(circle at 15% 18%,rgba(216,180,90,.09),transparent 24%),#050505}.halisi-signup-page *,.halisi-signup-page *:before,.halisi-signup-page *:after{box-sizing:border-box}
                        .halisi-signup-page:before{content:"";position:fixed;inset:0;pointer-events:none;opacity:.18;background-image:linear-gradient(rgba(255,255,255,.025) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,.025) 1px,transparent 1px);background-size:38px 38px;mask-image:linear-gradient(to bottom,#000,transparent 72%)}
                        .halisi-signup-shell{width:min(1180px,calc(100% - 34px));max-width:100vw;min-height:100vh;margin:0 auto;padding:28px 0 54px;display:grid;grid-template-columns:minmax(300px,.88fr) minmax(380px,1.12fr);gap:0;align-items:stretch;position:relative}.halisi-signup-shell>*{min-width:0}.halisi-signup-hero{position:relative;min-height:680px;padding:42px clamp(28px,5vw,64px);display:flex;flex-direction:column;justify-content:space-between;color:white;background:linear-gradient(145deg,#041535,#082a66 58%,#020d21);border-radius:30px 0 0 30px;border:1px solid rgba(255,218,111,.52);border-right:0;overflow:hidden;isolation:isolate}.uh-signup-page .halisi-signup-hero{background:linear-gradient(145deg,#050505,#101010 58%,#050505);border-color:var(--line)}
                        .halisi-signup-hero:before{content:"";position:absolute;width:520px;height:520px;border:1px solid rgba(255,217,120,.18);border-radius:50%;right:-260px;top:-150px;box-shadow:0 0 0 46px rgba(255,217,120,.025),0 0 0 92px rgba(255,217,120,.016);z-index:-1}.uh-signup-page .halisi-signup-hero:before{border-color:rgba(255,88,207,.20);box-shadow:0 0 0 46px rgba(255,88,207,.025),0 0 0 92px rgba(216,180,90,.02)}
                        .halisi-signup-brand{display:flex;align-items:center;gap:16px;text-decoration:none;color:inherit}.halisi-signup-logo{width:84px;height:84px;border-radius:24px;overflow:hidden;border:1px solid rgba(255,219,120,.82);background:rgba(255,255,255,.04);box-shadow:0 18px 46px rgba(0,0,0,.34),0 0 34px rgba(227,185,77,.10)}.uh-signup-page .halisi-signup-logo{border-radius:50%;border-color:rgba(216,180,90,.65)}.halisi-signup-logo img{width:100%;height:100%;object-fit:cover}.uh-signup-page .halisi-signup-logo img{object-fit:contain}.halisi-signup-brand-copy{display:grid;gap:5px;line-height:1.05}.halisi-signup-brand-copy small{color:var(--gold-2);font-weight:850;letter-spacing:.22em;text-transform:uppercase;font-size:.70rem}.uh-signup-page .halisi-signup-brand-copy small{color:#f0d88c}.halisi-signup-brand-copy strong{color:white;font-family:Georgia,"Times New Roman",serif;font-size:clamp(1.35rem,2.2vw,2rem);font-weight:500}.uh-signup-page .halisi-signup-brand-copy strong{color:var(--pink-2)}
                        .halisi-signup-copy{max-width:100%;padding:70px 0 52px}.halisi-signup-eyebrow{margin:0 0 18px;color:var(--gold-2);text-transform:uppercase;letter-spacing:.20em;font-size:.72rem;font-weight:900}.halisi-signup-copy h1{margin:0;color:white;font-family:Georgia,"Times New Roman",serif;font-weight:500;font-size:clamp(2.15rem,3.55vw,3.9rem);line-height:1.02;letter-spacing:-.035em;overflow-wrap:break-word}.uh-signup-page .halisi-signup-copy h1{font-family:Inter,ui-sans-serif,system-ui,sans-serif;font-weight:850;letter-spacing:-.05em}.halisi-signup-copy h1 em{display:block;margin-top:10px;color:var(--gold-2);font-style:normal}.uh-signup-page .halisi-signup-copy h1 em{color:var(--pink-2)}.halisi-signup-copy p:not(.halisi-signup-eyebrow){margin:22px 0 0;color:rgba(255,255,255,.74);font-size:1rem;line-height:1.72;max-width:500px}
                        .halisi-signup-principles{display:flex;flex-wrap:wrap;gap:10px}.halisi-signup-principles span{display:inline-flex;align-items:center;gap:8px;border:1px solid rgba(255,215,104,.30);background:rgba(255,255,255,.065);backdrop-filter:blur(12px);border-radius:999px;color:#f7e7ae;padding:10px 14px;font-size:.78rem;font-weight:750}.uh-signup-page .halisi-signup-principles span{border-color:rgba(255,88,207,.22);color:rgba(255,255,255,.82)}
                        .halisi-signup-form-side{min-width:0;width:100%;min-height:680px;padding:44px clamp(24px,4.5vw,72px);background:linear-gradient(180deg,#fffefa,#fff9ed);border-radius:0 30px 30px 0;border:1px solid rgba(255,218,111,.52);border-left:0;display:flex;flex-direction:column;justify-content:center;position:relative;overflow:hidden}.uh-signup-page .halisi-signup-form-side{background:linear-gradient(180deg,rgba(255,255,255,.055),rgba(255,255,255,.025));border-color:var(--line);color:white;backdrop-filter:blur(8px)}.halisi-signup-form-side:before{content:"";position:absolute;top:0;left:0;right:0;height:4px;background:linear-gradient(90deg,var(--navy),var(--gold-2),var(--navy))}.uh-signup-page .halisi-signup-form-side:before{background:linear-gradient(90deg,var(--pink),var(--gold),var(--pink))}
                        .halisi-signup-mobile-brand{display:none;margin-bottom:24px}.halisi-signup-intro{margin-bottom:24px}.halisi-signup-intro h2{margin:0;font-family:Georgia,"Times New Roman",serif;font-weight:500;color:#09265d;font-size:clamp(2.05rem,4vw,3.2rem);letter-spacing:-.035em;line-height:1}.uh-signup-page .halisi-signup-intro h2{font-family:Inter,ui-sans-serif,system-ui,sans-serif;font-weight:850;color:var(--pink-2);letter-spacing:-.045em}.halisi-signup-intro p{margin:12px 0 0;color:#6d7280;font-size:.95rem;line-height:1.6}.uh-signup-page .halisi-signup-intro p{color:rgba(255,255,255,.62)}.halisi-signup-progress{margin-top:18px;height:9px;border-radius:999px;background:rgba(9,38,93,.10);overflow:hidden}.uh-signup-page .halisi-signup-progress{background:rgba(255,255,255,.10)}.halisi-signup-progress span{display:block;height:100%;border-radius:inherit;background:linear-gradient(90deg,var(--gold-2),var(--gold));transition:width .25s ease}.uh-signup-page .halisi-signup-progress span{background:linear-gradient(90deg,var(--pink),var(--pink-2),var(--gold))}
                        .halisi-signup-page .signup-question-frame,.halisi-signup-page .signup-review-frame{width:100%;max-width:100%;margin:0;background:rgba(9,38,93,.04);border:1px solid rgba(9,38,93,.10);box-shadow:0 20px 60px rgba(9,38,93,.10);border-radius:24px;padding:24px;color:#09265d}.uh-signup-page .signup-question-frame,.uh-signup-page .signup-review-frame{background:rgba(255,255,255,.055);border-color:rgba(216,180,90,.18);box-shadow:0 24px 70px rgba(0,0,0,.30);color:white}.halisi-signup-page .signup-question-frame p,.halisi-signup-page .signup-review-frame p{color:#09265d!important;overflow-wrap:break-word}.uh-signup-page .signup-question-frame p,.uh-signup-page .signup-review-frame p{color:rgba(255,255,255,.88)!important}.halisi-signup-page .signup-question-frame p:first-child,.halisi-signup-page .signup-review-frame>p:first-child{color:#a87918!important;text-transform:uppercase;letter-spacing:.12em;font-weight:900}.uh-signup-page .signup-question-frame p:first-child,.uh-signup-page .signup-review-frame>p:first-child{color:#f0d88c!important}
                        .halisi-signup-page .signup-question-frame p.text-base,.halisi-signup-page .signup-question-frame label{color:var(--gold)!important}
                        .halisi-signup-page input:not([type="range"]),.halisi-signup-page textarea{display:block;width:100%;max-width:100%;border:1px solid rgba(9,38,93,.14)!important;border-radius:16px!important;background:rgba(255,255,255,.94)!important;color:#071b45!important;padding:14px 18px!important;outline:0;box-shadow:0 1px 0 rgba(255,255,255,.75) inset}.uh-signup-page input:not([type="range"]),.uh-signup-page textarea{border-color:rgba(216,180,90,.24)!important;background:rgba(255,255,255,.08)!important;color:white!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.05)}.halisi-signup-page input::placeholder,.halisi-signup-page textarea::placeholder{color:#8e98a5}.uh-signup-page input::placeholder,.uh-signup-page textarea::placeholder{color:rgba(255,255,255,.45)}.halisi-signup-page input[type="range"]{accent-color:var(--gold);max-width:100%}.uh-signup-page input[type="range"]{accent-color:var(--pink-2)}
                        .halisi-signup-page button{max-width:100%;overflow-wrap:anywhere}.halisi-signup-page .signup-question-frame button,.halisi-signup-page .signup-review-frame button{border-radius:999px!important;border:1px solid rgba(9,38,93,.12);font-weight:900;letter-spacing:.04em}.halisi-signup-page .signup-question-frame button[class*="bg-primary"],.halisi-signup-page .signup-review-frame button[class*="bg-primary"]{background:linear-gradient(135deg,#ffe58b 0%,#f7c84f 48%,#c98c1d 100%)!important;color:#071b45!important;box-shadow:0 14px 28px rgba(201,140,29,.20)}.uh-signup-page .signup-question-frame button[class*="bg-primary"],.uh-signup-page .signup-review-frame button[class*="bg-primary"]{background:linear-gradient(135deg,var(--pink),var(--pink-2) 52%,var(--gold))!important;color:#050505!important}.halisi-signup-page .signup-question-frame button[class*="bg-white"],.halisi-signup-page .signup-review-frame button[class*="bg-white"]{background:#fff!important;color:#09265d!important}.uh-signup-page .signup-question-frame button[class*="bg-white"],.uh-signup-page .signup-review-frame button[class*="bg-white"]{background:rgba(255,255,255,.10)!important;color:white!important;border-color:rgba(216,180,90,.24)}
                        @media(max-width:900px){.halisi-signup-shell{width:100%;max-width:100vw;padding:0;display:block}.halisi-signup-hero{display:none}.halisi-signup-form-side{min-height:100vh;width:100%;max-width:100vw;border-radius:0;border:0;padding:28px 16px;overflow:visible}.halisi-signup-mobile-brand{display:flex}.halisi-signup-logo{width:78px;height:78px}.halisi-signup-brand-copy small{letter-spacing:.16em}.halisi-signup-intro h2{font-size:clamp(2rem,11vw,3rem)}.halisi-signup-intro p{font-size:.9rem}.halisi-signup-page .signup-question-frame,.halisi-signup-page .signup-review-frame{padding:20px 16px;border-radius:20px}.halisi-signup-page .grid{max-width:100%}}
                    `}</style>
                    <main className="halisi-signup-shell">
                        <aside className="halisi-signup-hero">
                            <div className="halisi-signup-brand"><span className="halisi-signup-logo"><img src={signupTheme.logo} alt={`${signupTheme.name} logo`} /></span><span className="halisi-signup-brand-copy"><small>{signupTheme.kicker}</small><strong>{signupTheme.name}</strong></span></div>
                            <div className="halisi-signup-copy"><p className="halisi-signup-eyebrow">Private application</p><h1>{signupTheme.title} <em>{signupTheme.accent}</em></h1><p>{signupTheme.subtitle}</p></div>
                            <div className="halisi-signup-principles"><span>Verified access</span><span>Intentional answers</span><span>Private matching</span></div>
                        </aside>
                        <section className="halisi-signup-form-side">
                            <div className="halisi-signup-brand halisi-signup-mobile-brand"><span className="halisi-signup-logo"><img src={signupTheme.logo} alt={`${signupTheme.name} logo`} /></span><span className="halisi-signup-brand-copy"><small>{signupTheme.kicker}</small><strong>{signupTheme.name}</strong></span></div>
                            <header className="halisi-signup-intro"><p className="halisi-signup-eyebrow">Sign up</p><h2>{currentstep === reviewIndex ? 'Review your answers.' : 'Complete your profile.'}</h2><p>{signupTheme.note}</p><div className="halisi-signup-progress" aria-label="Signup progress"><span style={{width: `${Math.min(100, Math.round(((currentstep + 1) / (finalStepIndex + 1)) * 100))}%`}}></span></div></header>
                            {formQuestions.map(function(item, index) {
                                if (index === numberofsteps-1) {
                                    return (
                                        <FormQuestion
                                            index={index}
                                            key={index}
                                            item={item}
                                            ForwardStep={ForwardStep}
                                            MinusStep={MinusStep}
                                            setField={setField}
                                            laststep={false}
                                            firststep={(index===0)}
                                            allrequired={props.allrequired}
                                            showitem={(index===currentstep)}
                                            rendersequentially={true}
                                            answers={allanswers}
                                            edit={props.edit}
                                            recaptcha={recaptcha}
                                        />
                                    )
                                } else {
                                    return (
                                        <React.Fragment key={index}>
                                            <FormQuestion
                                                index={index}
                                                item={item}
                                                ForwardStep={ForwardStep}
                                                MinusStep={MinusStep}
                                                laststep={false}
                                                setField={setField}
                                                firststep={(index===0)}
                                                showitem={(index===currentstep)}
                                                rendersequentially={true}
                                                answers={allanswers}
                                                edit={props.edit}
                                                allrequired={props.allrequired}
                                                recaptcha={recaptcha}
                                            />
                                        </React.Fragment>
                                    )
                                }
                            })}
                            {renderSignupCompletion()}
                        </section>
                    </main>
                </div>
            )
        }
        return (
            <div ref={viewportRoot} className={`league-spartan mb-3 min-h-screen flex flex-col items-center justify-center md:justify-start${fitSignupViewport ? ' signup-viewport-page' : ''}`}>
                {formQuestions.map(function(item, index) {
                    if (index === numberofsteps-1) {
                        return (
                            <FormQuestion
                                index={index}
                                key={index}
                                item={item}
                                ForwardStep={ForwardStep}
                                MinusStep={MinusStep}
                                setField={setField}
                                laststep={false}
                                firststep={(index===0)}
                                allrequired={props.allrequired}
                                showitem={(index===currentstep)}
                                rendersequentially={true}
                                answers={allanswers}
                                edit={props.edit}
                                recaptcha={recaptcha}
                            />
                        )
                    } else {
                        return (
                            <>
                                <FormQuestion
                                    index={index}
                                    key={index}
                                    item={item}
                                    ForwardStep={ForwardStep}
                                    MinusStep={MinusStep}
                                    laststep={false}
                                    setField={setField}
                                    firststep={(index===0)}
                                    showitem={(index===currentstep)}
                                    rendersequentially={true}
                                    answers={allanswers}
                                    edit={props.edit}
                                    allrequired={props.allrequired}
                                    recaptcha={recaptcha}
                                />
                            </>
                        )
                    }
                })}
                {renderSignupCompletion()}
            </div>
        )
    }
}

export function Login(props) {
    const [allanswers, setAllAnswers] = React.useState(fillerprofiledata())
    const [showExpiredAccountModal, setShowExpiredAccountModal] = React.useState(false)
    let navigate = useNavigate();

    React.useEffect(() => {
        trackEvent('login_page_visit');
    }, []);
    
    function setField(value, field) {
        var currentanswers = allanswers;
        console.log("Newthing ", currentanswers);
        currentanswers[field] = value
        setAllAnswers(currentanswers)
        console.log(allanswers)
    }

    function handleSubmit(event) {
        if (event) event.preventDefault()
        trackEvent('login_submit_pressed')
        const url = props.url;
        const formData = new FormData();
        for (var key in allanswers) {
            formData.append(key, allanswers[key]) 
        }
        
        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            },
        };

        console.log(formData)
        postData(url, formData, config).then((data) => {
            console.log(data);
            if (data.responsecode === 200) {
                if (data.indebt) {
                    alert('Your account is in arrears. To have full access to your account, kindly liaise with WhatsApp Support.')
                    navigate('/login')
                    return
                }
                setLoginCookies(allanswers['EMAIL'], data.auth_cookie)
                trackEvent('login_success', { user: allanswers['EMAIL'] })
                navigate('/myprofile/'+Base64.encode(allanswers['EMAIL']))
            } else if (isExpiredAccountLoginResponse(data)) {
                trackEvent('login_failed', { reason: 'account_expired' })
                setShowExpiredAccountModal(true)
            } else if (data.responsecode === 404) {
                trackEvent('login_failed', { reason: 'email_invalid' })
                const message = (data && data.message) ? data.message : "Your email is invalid."
                alert(message)
            } else if (data.responsecode === 403) {
                trackEvent('login_failed', { reason: 'password_incorrect' })
                alert("Your password is incorrect. You can click forgot password if you've forgotten it. Otherwise, please try again.")
            } else if (data.responsecode === 503) {
                alert("The site is currently under maintenance.")
            } else {
                alert("Something went wrong. Please contact support.")
            }
        }).catch((err) => {
            console.log("Error in setProfiledataSubmit: ", err);
            throw err;
        });

    }
    return (
        <>
        <ExpiredAccountModal show={showExpiredAccountModal} onClose={() => setShowExpiredAccountModal(false)} />
        <div className="league-spartan mb-3 min-h-screen flex flex-col justify-center md:justify-start">
            <a className="col-12 w-full py-2 px-20 bg-primary border border-white text-white text-xl font-bold" href="/">
                LOGIN
            </a>
            
            <motion.form
                className="flex flex-col"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{duration:1}}
                onSubmit={handleSubmit}
              >
                <input className="bg-white text-black placeholder-gray-600 p-2 my-2 rounded-full" placeholder='Email:' onFocus={() => trackEvent('login_email_input')} onChange={(e) => setField(e.target.value, "EMAIL")}/>
                <input className="bg-white text-black placeholder-gray-600 p-2 my-2 rounded-full" placeholder='Password:' type='password' onFocus={() => trackEvent('login_password_input')} onChange={(e) => setField(e.target.value, "password")}/>

                <button type='submit' className="w-full text-black bg-white p-2 my-3 rounded-full">LOGIN</button>
                <Link to='/forgottenpassword' onClick={() => trackEvent('login_forgot_password_clicked')} className="w-full text-black text-xs bg-white p-1 my-1 rounded-full">FORGOT PASSWORD</Link>
            </motion.form>
        </div>
        </>
    )
}

export function GoogleEnabledLogin(props) {
    const [welcomeDestination, setWelcomeDestination] = React.useState('');
    const [allanswers, setAllAnswers] = React.useState(fillerprofiledata())
    const [showExpiredAccountModal, setShowExpiredAccountModal] = React.useState(false)
    const navigate = useNavigate();
    const finishWelcome = React.useCallback(() => navigate(welcomeDestination), [welcomeDestination, navigate]);

    React.useEffect(() => {
        trackEvent('login_page_visit');
        const redirectKey = 'loginAuthenticatedRedirectAttempted';
        const hasExistingSession = Boolean(Cookies.get('email') && Cookies.get('auth'));
        if (hasExistingSession && sessionStorage.getItem(redirectKey) !== 'true') {
            sessionStorage.setItem(redirectKey, 'true');
            trackEvent('login_authenticated_redirect_home');
            window.location.replace('/');
        }
    }, [navigate]);

    const handleSuccess = (credentialResponse) => {
        trackEvent('login_google_success')
        const url = "/api/googleauth"
        console.log("Here:", credentialResponse);
        const decryptedjwt = jwtDecode(credentialResponse.credential)
        console.log("Decrypted:", decryptedjwt)
        const formData = new FormData();
        for (var key in decryptedjwt) {
            formData.append(key, decryptedjwt[key]) 
        }
        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            },
        };
        console.log(formData)
        postData(url, formData, config).then((data) => {
            console.log(data);
            if (data.responsecode === 200) {
                if (data.indebt) {
                    alert('Your account is in arrears. To have full access to your account, kindly liaise with WhatsApp Support.')
                    navigate('/login')
                    return
                }
                const email = decryptedjwt.email.toLowerCase().trim();
                setLoginCookies(email, data.auth_cookie)
                trackEvent('login_success', { user: email })
                setWelcomeDestination('/myprofile/'+Base64.encode(email))
            } else if (isExpiredAccountLoginResponse(data)) {
                trackEvent('login_failed', { reason: 'account_expired' })
                setShowExpiredAccountModal(true)
            } else if (data.responsecode === 404) {
                trackEvent('login_failed', { reason: 'email_invalid' })
                const message = (data && data.message) ? data.message : "Your email is invalid."
                alert(message)
            } else if (data.responsecode === 503) {
                alert("The site is currently under maintenance.")
            } else {
                alert("Something went wrong. Please contact support.")
            }
        }).catch((err) => {
            console.log("Something went wrong: ", err)
        });
    };
    
    const handleError = () => {
        trackEvent('login_google_failed')
        console.log('Login Failed');
    };

    function setField(value, field) {
        if (field === "EMAIL") {
            if (value.includes(" ")) {
                alert("Your email cannot contain spaces. Please remove the spaces and try again.")
                return
            }
            if (/[A-Z]/.test(value)) {
                alert("Your email cannot contain capital letters. Please use lowercase letters only.");
                return;
            }
        } 
        var currentanswers = allanswers;
        console.log("Newthing ", currentanswers);
        currentanswers[field] = value
        setAllAnswers(currentanswers)
        console.log(allanswers)
    }

    function handleSubmit(event) {
        if (event) event.preventDefault()
        trackEvent('login_submit_pressed')
        const url = props.url;
        const formData = new FormData();
        for (var key in allanswers) {
            formData.append(key, allanswers[key]) 
        }
        
        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            },
        };
        console.log(formData)
        

        postData(url, formData, config).then((data) => {
            console.log(data);
            if (data.responsecode === 200) {
                if (data.indebt) {
                    alert('Your account is in arrears. To have full access to your account, kindly liaise with WhatsApp Support.')
                    navigate('/login')
                    return
                }
                const email = allanswers['EMAIL'].toLowerCase().trim();
                setLoginCookies(email, data.auth_cookie)
                trackEvent('login_success', { user: email })
                setWelcomeDestination('/myprofile/'+Base64.encode(email))
            } else if (isExpiredAccountLoginResponse(data)) {
                trackEvent('login_failed', { reason: 'account_expired' })
                setShowExpiredAccountModal(true)
            } else if (data.responsecode === 404) {
                trackEvent('login_failed', { reason: 'email_invalid' })
                const message = (data && data.message) ? data.message : `Your email ${allanswers['EMAIL']} is invalid.`
                alert(message)
            } else if (data.responsecode === 403) {
                trackEvent('login_failed', { reason: 'password_incorrect' })
                alert("Your password is incorrect. You can click forgot password if you've forgotten it. Otherwise, please try again.")
            } else if (data.responsecode === 503) {
                alert("The site is currently under maintenance.")
            } else {
                alert("Something went wrong. Please contact support.")
            }
        }).catch((err) => {
            console.log("Error in setProfiledataSubmit: ", err);
            throw err;
        });

    }
    const [showPassword, setShowPassword] = React.useState(false)
    const [showSapphirePromoModal, setShowSapphirePromoModal] = React.useState(() => Cookies.get(SAPPHIRE_LOGIN_PROMO_COOKIE) !== 'true')

    function dismissSapphirePromoModal() {
        Cookies.set(SAPPHIRE_LOGIN_PROMO_COOKIE, 'true', { expires: 365 })
        setShowSapphirePromoModal(false)
    }

    function renderSapphirePromoModal() {
        if (!showSapphirePromoModal) return null

        return (
            <div className="sapphire-login-promo" role="dialog" aria-modal="true" aria-label="Sapphire Package video messaging and video calling promotion">
                <style>{`
                    .sapphire-login-promo{position:fixed;inset:0;z-index:1000;display:flex;align-items:center;justify-content:center;padding:18px;background:rgba(0,0,0,.74);backdrop-filter:blur(5px)}
                    .sapphire-login-promo-card{position:relative;width:min(540px,100%);max-height:calc(100vh - 36px);overflow:auto;border:1px solid rgba(255,218,111,.58);border-radius:24px;background:#050505;box-shadow:0 28px 90px rgba(0,0,0,.55)}
                    .sapphire-login-promo-image{display:block;width:100%;height:auto;border-radius:23px 23px 0 0}
                    .sapphire-login-promo-actions{display:flex;gap:12px;justify-content:center;padding:14px;background:linear-gradient(180deg,#050505,#120d03)}
                    .sapphire-login-promo-continue{border:0;border-radius:999px;background:linear-gradient(135deg,#ffe58b,#f7c84f 52%,#c98c1d);color:#071b45;cursor:pointer;font-weight:950;letter-spacing:.08em;padding:13px 24px;text-transform:uppercase}
                    .sapphire-login-promo-close{position:absolute;top:10px;right:10px;width:38px;height:38px;border:1px solid rgba(255,218,111,.55);border-radius:999px;background:rgba(0,0,0,.62);color:#fff;cursor:pointer;font-size:24px;line-height:1}
                `}</style>
                <div className="sapphire-login-promo-card">
                    <button className="sapphire-login-promo-close" type="button" aria-label="Close Sapphire Package promotion" onClick={dismissSapphirePromoModal}>×</button>
                    <img className="sapphire-login-promo-image" src={SapphireLoginPromoImage} alt="Sapphire Package: video messaging, video calling, and limited time 50% discount" />
                    <div className="sapphire-login-promo-actions">
                        <button className="sapphire-login-promo-continue" type="button" onClick={dismissSapphirePromoModal}>Continue to login</button>
                    </div>
                </div>
            </div>
        )
    }

    if (welcomeDestination) return <MemberWelcomeVideo onContinue={finishWelcome} />;

    const hostname = window.location.hostname || "";
    const isExpatElite = hostname.includes("expatelitesingles.com") || hostname === "localhost" || hostname === "127.0.0.1";

    if (!isExpatElite) {
        const isUpendoHalisi = /(^|\.)upendo-halisi\.com$/i.test(hostname)
        const isPenziHalisi = hostname.includes("penzi-halisi.com")
        const siteTheme = isUpendoHalisi
            ? {
                key: 'uh',
                name: 'Upendo Halisi',
                kicker: 'Meet someone worth knowing',
                title: 'Welcome back to Upendo Halisi.',
                subtitle: 'Return to your private account and continue meaningful introductions with serious-minded singles.',
                logo: '/assets/img/uhlogo.jpeg',
                accent: 'Personal · warm · intentional',
                privacy: 'Your account access stays private and protected.',
            }
            : {
                key: isPenziHalisi ? 'ph' : 'ph',
                name: '',
                kicker: 'Genuine connections',
                title: 'Welcome back to Penzi Halisi.',
                subtitle: 'Continue your journey with a relationship-focused platform built for genuine conversations.',
                logo: '/assets/img/phlogo.jpeg',
                accent: 'Verified · focused · sincere',
                privacy: 'Your account access stays private and protected.',
            }

        return (
            <>
            {renderSapphirePromoModal()}
            <ExpiredAccountModal show={showExpiredAccountModal} onClose={() => setShowExpiredAccountModal(false)} />
            <div className={`halisi-login-page ${siteTheme.key}-login-page`}>
                <style>{`
                    .halisi-login-page{--navy:#041535;--navy-2:#082b68;--navy-3:#0e3d89;--gold:#e3b94d;--gold-2:#ffd978;--gold-3:#fff0ba;--ivory:#fffaf0;--ink:#0d2146;--green:#25D366;--pink:#ff58cf;--pink-2:#ff89dd;--line:rgba(211,166,53,.28);--shadow:0 35px 90px rgba(0,0,0,.35);position:fixed;inset:0;z-index:20;min-height:100vh;overflow:auto;font-family:Inter,ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;color:var(--ink);background:radial-gradient(circle at 20% 4%,rgba(35,91,177,.52),transparent 25%),radial-gradient(circle at 92% 14%,rgba(223,176,56,.12),transparent 20%),linear-gradient(145deg,#03122d 0%,#082a66 47%,#020d21 100%)}
                    .uh-login-page{--line:rgba(216,180,90,.24);--shadow:0 35px 90px rgba(0,0,0,.52);color:#fff;background:radial-gradient(circle at 50% -10%,rgba(255,88,207,.13),transparent 28%),radial-gradient(circle at 15% 18%,rgba(216,180,90,.09),transparent 24%),#050505}
                    .halisi-login-page *,.halisi-login-page *:before,.halisi-login-page *:after{box-sizing:border-box}.halisi-login-page:before{content:"";position:fixed;inset:0;pointer-events:none;opacity:.18;background-image:linear-gradient(rgba(255,255,255,.025) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,.025) 1px,transparent 1px);background-size:38px 38px;mask-image:linear-gradient(to bottom,#000,transparent 72%)}
                    .halisi-login-shell{width:min(1180px,calc(100% - 34px));max-width:100vw;min-height:100vh;margin:0 auto;padding:28px 0 54px;display:flex;align-items:center;justify-content:center;position:relative}.halisi-card{width:100%;display:grid;grid-template-columns:minmax(330px,.95fr) minmax(360px,1.05fr);overflow:hidden;border-radius:30px;border:1px solid rgba(255,218,111,.52);background:rgba(255,255,255,.99);box-shadow:var(--shadow)}.halisi-card>*{min-width:0}
                    .uh-login-page .halisi-card{border-color:var(--line);background:linear-gradient(180deg,rgba(255,255,255,.035),rgba(255,255,255,.012));backdrop-filter:blur(8px)}
                    .halisi-brand-panel{position:relative;min-height:680px;padding:42px clamp(28px,5vw,64px);display:flex;flex-direction:column;justify-content:space-between;color:white;background:linear-gradient(145deg,#041535,#082a66 58%,#020d21);isolation:isolate;overflow:hidden}.uh-login-page .halisi-brand-panel{background:linear-gradient(145deg,#050505,#101010 58%,#050505)}
                    .halisi-brand-panel:before{content:"";position:absolute;width:520px;height:520px;border:1px solid rgba(255,217,120,.18);border-radius:50%;right:-260px;top:-150px;box-shadow:0 0 0 46px rgba(255,217,120,.025),0 0 0 92px rgba(255,217,120,.016);z-index:-1}.uh-login-page .halisi-brand-panel:before{border-color:rgba(255,88,207,.20);box-shadow:0 0 0 46px rgba(255,88,207,.025),0 0 0 92px rgba(216,180,90,.02)}
                    .halisi-brand-panel:after{content:"";position:absolute;left:-90px;bottom:-160px;width:430px;height:430px;border-radius:50%;background:radial-gradient(circle,rgba(227,185,77,.20),transparent 67%);z-index:-1}.uh-login-page .halisi-brand-panel:after{background:radial-gradient(circle,rgba(255,88,207,.18),transparent 67%)}
                    .halisi-brand{display:flex;align-items:center;gap:16px;text-decoration:none;color:inherit}.halisi-logo{width:84px;height:84px;border-radius:24px;overflow:hidden;border:1px solid rgba(255,219,120,.82);background:rgba(255,255,255,.04);box-shadow:0 18px 46px rgba(0,0,0,.34),0 0 34px rgba(227,185,77,.10)}.uh-login-page .halisi-logo{border-radius:50%;border-color:rgba(216,180,90,.65)}.halisi-logo img{width:100%;height:100%;object-fit:cover}.uh-login-page .halisi-logo img{object-fit:contain}.halisi-brand-copy{display:grid;gap:5px;line-height:1.05}.halisi-brand-copy small{color:var(--gold-2);font-weight:850;letter-spacing:.22em;text-transform:uppercase;font-size:.70rem}.uh-login-page .halisi-brand-copy small{color:var(--gold-soft,#f0d88c)}.halisi-brand-copy strong{color:white;font-family:Georgia,"Times New Roman",serif;font-size:clamp(1.35rem,2.2vw,2rem);font-weight:500}.uh-login-page .halisi-brand-copy strong{color:var(--pink-2)}
                    .halisi-copy{max-width:100%;padding:70px 0 52px}.halisi-eyebrow{margin:0 0 18px;color:var(--gold-2);text-transform:uppercase;letter-spacing:.20em;font-size:.72rem;font-weight:900}.uh-login-page .halisi-eyebrow{color:var(--gold-soft,#f0d88c)}.halisi-copy h1{margin:0;color:white;font-family:Georgia,"Times New Roman",serif;font-weight:500;font-size:clamp(2.15rem,3.55vw,3.9rem);line-height:1.02;letter-spacing:-.035em;overflow-wrap:break-word}.uh-login-page .halisi-copy h1{font-family:Inter,ui-sans-serif,system-ui,sans-serif;font-weight:850;letter-spacing:-.05em}.halisi-copy h1 em{display:block;margin-top:10px;color:var(--gold-2);font-style:normal}.uh-login-page .halisi-copy h1 em{color:var(--pink-2)}.halisi-copy p:not(.halisi-eyebrow){margin:22px 0 0;color:rgba(255,255,255,.74);font-size:1rem;line-height:1.72;max-width:500px}.halisi-principles{display:flex;flex-wrap:wrap;gap:10px}.halisi-principles span{display:inline-flex;align-items:center;gap:8px;border:1px solid rgba(255,215,104,.30);background:rgba(255,255,255,.065);backdrop-filter:blur(12px);border-radius:999px;color:#f7e7ae;padding:10px 14px;font-size:.78rem;font-weight:750}.uh-login-page .halisi-principles span{border-color:rgba(255,88,207,.22);color:rgba(255,255,255,.82)}.halisi-principles i{width:8px;height:8px;border-radius:99px;background:#42d887;box-shadow:0 0 0 5px rgba(66,216,135,.10)}
                    .halisi-form-side{min-width:0;width:100%;min-height:680px;display:grid;place-items:center;padding:44px clamp(28px,5vw,78px);background:linear-gradient(180deg,#fffefa,#fff9ed);position:relative}.uh-login-page .halisi-form-side{background:linear-gradient(180deg,rgba(255,255,255,.055),rgba(255,255,255,.025));color:white}.halisi-form-side:before{content:"";position:absolute;top:0;left:0;right:0;height:4px;background:linear-gradient(90deg,var(--navy),var(--gold-2),var(--navy))}.uh-login-page .halisi-form-side:before{background:linear-gradient(90deg,var(--pink),var(--gold),var(--pink))}.halisi-login-wrap{width:min(470px,100%);max-width:100%;min-width:0}.halisi-mobile-brand{display:none}.halisi-heading{margin-bottom:32px}.halisi-heading .halisi-eyebrow{color:#aa7a19;margin-bottom:14px}.uh-login-page .halisi-heading .halisi-eyebrow{color:var(--gold-soft,#f0d88c)}.halisi-heading h2{margin:0;font-family:Georgia,"Times New Roman",serif;font-weight:500;color:#09265d;font-size:clamp(2.35rem,4vw,3.4rem);letter-spacing:-.035em;line-height:1}.uh-login-page .halisi-heading h2{font-family:Inter,ui-sans-serif,system-ui,sans-serif;font-weight:850;color:var(--pink-2);letter-spacing:-.045em}.halisi-heading p:not(.halisi-eyebrow){margin:14px 0 0;color:#6d7280;font-size:.95rem;line-height:1.65}.uh-login-page .halisi-heading p:not(.halisi-eyebrow){color:rgba(255,255,255,.62)}
                    .halisi-form{display:grid;gap:20px}.halisi-field{display:grid;gap:8px}.halisi-field-row{min-width:0;display:flex;align-items:center;justify-content:space-between;gap:12px;flex-wrap:wrap}.halisi-label{font-size:.70rem;font-weight:900;text-transform:uppercase;letter-spacing:.12em;color:#5d5047}.uh-login-page .halisi-label{color:rgba(255,255,255,.76)}.halisi-forgot{max-width:100%;overflow-wrap:anywhere;text-align:right;font-size:.72rem;color:#09265d;font-weight:850;text-decoration:none;border-bottom:1px solid rgba(9,38,93,.25);padding-bottom:2px}.uh-login-page .halisi-forgot{color:var(--gold-soft,#f0d88c);border-bottom-color:rgba(240,216,140,.35)}.halisi-input-shell{position:relative}.halisi-input{display:block;width:100%;max-width:100%;height:58px;border:1px solid rgba(9,38,93,.14);border-radius:16px;background:rgba(255,255,255,.90);color:#071b45;padding:0 18px;outline:0;box-shadow:0 1px 0 rgba(255,255,255,.75) inset;transition:border-color .2s ease,box-shadow .2s ease,background .2s ease}.uh-login-page .halisi-input{border-color:rgba(216,180,90,.24);background:rgba(255,255,255,.08);color:white;box-shadow:inset 0 1px 0 rgba(255,255,255,.05)}.halisi-input::placeholder{color:#9aa2ad}.uh-login-page .halisi-input::placeholder{color:rgba(255,255,255,.45)}.halisi-input:focus{border-color:var(--gold);background:#fff;box-shadow:0 0 0 4px rgba(227,185,77,.14)}.uh-login-page .halisi-input:focus{border-color:var(--pink-2);background:rgba(255,255,255,.12);box-shadow:0 0 0 4px rgba(255,88,207,.10)}.halisi-password{padding-right:56px}.halisi-eye{position:absolute;top:50%;right:9px;transform:translateY(-50%);width:42px;height:42px;border:0;border-radius:12px;background:transparent;color:#687385;display:grid;place-items:center;cursor:pointer}.uh-login-page .halisi-eye{color:rgba(255,255,255,.58)}.halisi-eye:hover{background:rgba(227,185,77,.12);color:#09265d}.uh-login-page .halisi-eye:hover{background:rgba(255,88,207,.10);color:white}
                    .halisi-login-btn{width:100%;max-width:100%;height:60px;border:0;border-radius:18px;background:linear-gradient(135deg,#ffe58b 0%,#f7c84f 48%,#c98c1d 100%);color:#071b45;font-weight:950;text-transform:uppercase;letter-spacing:.09em;box-shadow:0 18px 35px rgba(201,140,29,.24);cursor:pointer;transition:transform .2s ease,filter .2s ease}.uh-login-page .halisi-login-btn{background:linear-gradient(135deg,var(--pink),var(--pink-2) 52%,var(--gold));color:#050505}.halisi-login-btn:hover{transform:translateY(-2px);filter:brightness(1.04)}.halisi-secondary-btn{height:46px;border:1px solid rgba(9,38,93,.14);border-radius:999px;background:rgba(255,255,255,.64);color:#09265d;font-weight:850;text-transform:uppercase;letter-spacing:.08em;cursor:pointer}.uh-login-page .halisi-secondary-btn{border-color:rgba(216,180,90,.24);background:rgba(255,255,255,.07);color:white}.halisi-divider{display:flex;align-items:center;gap:12px;color:#897b68;font-size:.72rem;text-transform:uppercase;letter-spacing:.16em;font-weight:900}.uh-login-page .halisi-divider{color:rgba(255,255,255,.46)}.halisi-divider:before,.halisi-divider:after{content:"";height:1px;flex:1;background:rgba(9,38,93,.14)}.uh-login-page .halisi-divider:before,.uh-login-page .halisi-divider:after{background:rgba(255,255,255,.12)}.halisi-google-wrap{display:flex;justify-content:center;min-height:44px;max-width:100%;overflow:hidden}.halisi-google-wrap>div,.halisi-google-wrap iframe{max-width:100%!important}.halisi-security{margin-top:22px;display:flex;gap:10px;align-items:flex-start;border:1px solid rgba(9,38,93,.10);border-radius:18px;background:rgba(255,255,255,.58);padding:13px 14px;color:#5b6472;font-size:.82rem;line-height:1.45}.uh-login-page .halisi-security{border-color:rgba(216,180,90,.18);background:rgba(255,255,255,.055);color:rgba(255,255,255,.62)}.halisi-security svg{width:19px;height:19px;flex:0 0 auto;color:#aa7a19}.uh-login-page .halisi-security svg{color:var(--pink-2)}
                    @media(max-width:900px){.halisi-login-page{overflow-x:hidden}.halisi-login-shell{width:100%;max-width:100vw;padding:0}.halisi-card{width:100%;max-width:100vw;grid-template-columns:minmax(0,1fr);border-radius:0;min-height:100vh}.halisi-brand-panel{display:none}.halisi-form-side{min-height:100vh;width:100%;max-width:100vw;padding:28px 16px}.halisi-mobile-brand{display:flex;margin-bottom:24px}.halisi-logo{width:78px;height:78px}.halisi-brand-copy small{letter-spacing:.16em}.halisi-heading{text-align:left}.halisi-heading h2{font-size:clamp(2.1rem,12vw,3rem)}.halisi-heading p:not(.halisi-eyebrow){font-size:.9rem;overflow-wrap:break-word}.halisi-google-wrap>div{width:100%!important;max-width:100%!important}}
                `}</style>
                <main className="halisi-login-shell">
                    <section className="halisi-card" aria-label={`${siteTheme.name} login`}>
                        <aside className="halisi-brand-panel">
                            <a className="halisi-brand" href="/" aria-label={`${siteTheme.name} home`}><span className="halisi-logo"><img src={siteTheme.logo} alt={`${siteTheme.name} logo`} /></span><span className="halisi-brand-copy"><small>{siteTheme.kicker}</small><strong>{siteTheme.name}</strong></span></a>
                            <div className="halisi-copy"><p className="halisi-eyebrow">Member access</p><h1>{siteTheme.title} <em>{siteTheme.accent}</em></h1><p>{siteTheme.subtitle}</p></div>
                            <div className="halisi-principles"><span><i></i>Private by design</span><span><i></i>Genuine introductions</span><span><i></i>Intentional matching</span></div>
                        </aside>
                        <section className="halisi-form-side">
                            <div className="halisi-login-wrap">
                                <a className="halisi-brand halisi-mobile-brand" href="/" aria-label={`${siteTheme.name} home`}><span className="halisi-logo"><img src={siteTheme.logo} alt={`${siteTheme.name} logo`} /></span><span className="halisi-brand-copy"><small>{siteTheme.kicker}</small><strong>{siteTheme.name}</strong></span></a>
                                <header className="halisi-heading"><p className="halisi-eyebrow">Secure sign in</p><h2>Log in.</h2><p>Continue to your private {siteTheme.name} account.</p></header>
                                <motion.form className="halisi-form" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{duration:1}} onSubmit={handleSubmit}>
                                    <div className="halisi-field"><label className="halisi-label" htmlFor="halisi-email">Email address</label><div className="halisi-input-shell"><input id="halisi-email" className="halisi-input" name="email" type="email" autoComplete="email" placeholder="you@example.com" required onFocus={() => trackEvent('login_email_input')} onChange={(e) => setField(e.target.value, "EMAIL")}/></div></div>
                                    <div className="halisi-field"><div className="halisi-field-row"><label className="halisi-label" htmlFor="halisi-password">Password</label><Link to='/forgottenpassword' onClick={() => trackEvent('login_forgot_password_clicked')} className="halisi-forgot">Forgot password?</Link></div><div className="halisi-input-shell"><input id="halisi-password" className="halisi-input halisi-password" name="password" type={showPassword ? 'text' : 'password'} autoComplete="current-password" placeholder="Enter your password" required onFocus={() => trackEvent('login_password_input')} onChange={(e) => setField(e.target.value, "password")}/><button className="halisi-eye" type="button" aria-label={showPassword ? 'Hide password' : 'Show password'} onClick={() => setShowPassword(!showPassword)}><svg viewBox="0 0 24 24" width="19" height="19" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true"><path d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6Z"/><circle cx="12" cy="12" r="2.8"/></svg></button></div></div>
                                    <button className="halisi-login-btn" type="submit">Log in</button>
                                    <div className="halisi-divider">or continue with</div>
                                    <div className="halisi-google-wrap"><GoogleLogin onSuccess={handleSuccess} onError={handleError} width="360" /></div>
                                </motion.form>
                                <div className="halisi-security"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true"><path d="M7 10V7a5 5 0 0 1 10 0v3"/><rect x="4.5" y="10" width="15" height="10" rx="2"/><path d="M12 14v2.5"/></svg><span>{siteTheme.privacy} Never share your password or verification details with anyone.</span></div>
                            </div>
                        </section>
                    </section>
                </main>
            </div>
            </>
        )
    }

    return (
        <>
        {renderSapphirePromoModal()}
        <ExpiredAccountModal show={showExpiredAccountModal} onClose={() => setShowExpiredAccountModal(false)} />
        <div className="ees-login-page">
            <style>{`
                .ees-login-page{--ink:#171411;--paper:#f5f0e8;--wine:#34191f;--wine-2:#4a202b;--wine-deep:#160d10;--gold:#bd9154;--gold-light:#e1c69d;--gold-pale:#f3e4cb;--serif:Georgia,"Times New Roman",serif;--sans:Inter,ui-sans-serif,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;position:fixed;inset:0;z-index:20;overflow:auto;min-height:100vh;text-transform:none;font-family:var(--sans);color:var(--ink);background:radial-gradient(circle at 12% 15%,rgba(225,198,157,.11),transparent 25%),radial-gradient(circle at 88% 82%,rgba(189,145,84,.12),transparent 30%),var(--wine-deep)}
                .ees-page{min-height:100vh;display:grid;grid-template-columns:minmax(360px,.92fr) minmax(440px,1.08fr);overflow:hidden}.ees-brand-panel{position:relative;min-height:100vh;padding:52px clamp(34px,5vw,78px);color:#fff;background:linear-gradient(155deg,rgba(24,13,16,.35),rgba(24,13,16,.84)),linear-gradient(135deg,var(--wine-2),var(--wine-deep));display:flex;flex-direction:column;justify-content:space-between;isolation:isolate;overflow:hidden}.ees-brand-panel:before{content:"";position:absolute;width:560px;height:560px;border:1px solid rgba(225,198,157,.16);border-radius:50%;right:-280px;top:-110px;box-shadow:0 0 0 48px rgba(225,198,157,.025),0 0 0 96px rgba(225,198,157,.018);z-index:-1}.ees-brand-panel:after{content:"";position:absolute;left:-70px;bottom:-170px;width:430px;height:430px;border-radius:50%;background:radial-gradient(circle,rgba(189,145,84,.16),transparent 67%);z-index:-1}.ees-brand{display:inline-flex;align-items:center;gap:15px;width:max-content}.ees-monogram{width:56px;height:56px;border:1px solid rgba(243,228,203,.72);display:grid;place-items:center;font-family:var(--serif);font-size:19px;letter-spacing:-2px;color:var(--gold-pale);position:relative}.ees-monogram:after{content:"";position:absolute;inset:5px;border:1px solid rgba(243,228,203,.18)}.ees-monogram span{font-size:12px;opacity:.72;margin:0 1px}.ees-brand-copy{display:grid;text-transform:uppercase;letter-spacing:.15em;line-height:1.05}.ees-brand-copy strong{font-size:14px}.ees-brand-copy small{margin-top:6px;font-size:9px;letter-spacing:.38em;color:var(--gold-light)}.ees-brand-body{max-width:560px;padding:70px 0 54px}.ees-eyebrow{margin:0 0 20px;color:var(--gold-light);text-transform:uppercase;letter-spacing:.21em;font-size:10px;font-weight:800}.ees-brand-body h1{margin:0;max-width:520px;font-family:var(--serif);font-weight:400;font-size:clamp(42px,5.1vw,74px);line-height:.98;letter-spacing:-.035em}.ees-brand-body h1 em{display:block;margin-top:10px;color:var(--gold-light);font-weight:400}.ees-brand-body p:not(.ees-eyebrow){margin:28px 0 0;max-width:460px;color:rgba(255,255,255,.67);font-size:14px;line-height:1.8}.ees-principles{display:flex;flex-wrap:wrap;gap:15px 22px;padding-top:25px;border-top:1px solid rgba(255,255,255,.13);color:rgba(255,255,255,.6);font-size:10px;text-transform:uppercase;letter-spacing:.13em;font-weight:700}.ees-principles span{display:flex;align-items:center;gap:8px}.ees-principles i{width:5px;height:5px;border-radius:50%;background:var(--gold-light);box-shadow:0 0 0 4px rgba(225,198,157,.08)}
                .ees-login-side{min-height:100vh;display:grid;place-items:center;padding:44px clamp(28px,5vw,86px);background:radial-gradient(circle at 100% 0,rgba(189,145,84,.10),transparent 31%),var(--paper);position:relative}.ees-login-side:before{content:"";position:absolute;top:0;left:0;right:0;height:4px;background:linear-gradient(90deg,var(--wine),var(--gold-light),var(--wine))}.ees-login-wrap{width:min(470px,100%)}.ees-mobile-brand{display:none}.ees-login-heading{margin-bottom:34px}.ees-login-heading .ees-eyebrow{color:var(--gold);margin-bottom:14px}.ees-login-heading h2{margin:0;font-family:var(--serif);font-weight:400;color:var(--wine-deep);font-size:clamp(38px,4vw,53px);letter-spacing:-.035em;line-height:1}.ees-login-heading p:not(.ees-eyebrow){margin:14px 0 0;color:#746a62;font-size:14px;line-height:1.65}.ees-form{display:grid;gap:20px}.ees-field{display:grid;gap:8px}.ees-field-row{display:flex;align-items:center;justify-content:space-between;gap:16px}.ees-label{font-size:11px;font-weight:800;text-transform:uppercase;letter-spacing:.11em;color:#5d5047}.ees-forgot{font-size:11px;color:var(--wine);font-weight:750;text-decoration:none;border-bottom:1px solid rgba(52,25,31,.25);padding-bottom:2px}.ees-input-shell{position:relative}.ees-input{width:100%;height:58px;border:1px solid rgba(23,20,17,.13);border-radius:14px;background:rgba(255,250,243,.82);color:var(--ink);padding:0 18px;outline:0;box-shadow:0 1px 0 rgba(255,255,255,.75) inset;transition:border-color .2s ease,box-shadow .2s ease,background .2s ease}.ees-input::placeholder{color:#a29a94}.ees-input:focus{border-color:var(--gold);background:#fffdf9;box-shadow:0 0 0 4px rgba(189,145,84,.11)}.ees-password{padding-right:56px}.ees-eye{position:absolute;top:50%;right:9px;transform:translateY(-50%);width:42px;height:42px;border:0;border-radius:10px;background:transparent;color:#766b62;display:grid;place-items:center;cursor:pointer}.ees-eye:hover{background:rgba(189,145,84,.09);color:var(--wine)}.ees-login-btn{height:58px;border:0;border-radius:999px;background:linear-gradient(115deg,#a7763c,var(--gold-light) 46%,#c99d61);color:#1c120b;text-transform:uppercase;letter-spacing:.15em;font-size:11px;font-weight:900;cursor:pointer;box-shadow:0 15px 34px rgba(87,54,26,.20);transition:transform .2s ease,box-shadow .2s ease,filter .2s ease}.ees-login-btn:hover{transform:translateY(-2px);box-shadow:0 19px 40px rgba(87,54,26,.25);filter:brightness(1.03)}.ees-divider{display:flex;align-items:center;gap:14px;margin:8px 0 0;color:#9a918a;font-size:10px;text-transform:uppercase;letter-spacing:.14em;font-weight:750}.ees-divider:before,.ees-divider:after{content:"";flex:1;height:1px;background:rgba(23,20,17,.11)}.ees-google-wrap{min-height:44px;display:flex;align-items:center;justify-content:center}.ees-security{display:flex;gap:11px;align-items:flex-start;margin-top:25px;padding-top:22px;border-top:1px solid rgba(23,20,17,.10);color:#80766e;font-size:11px;line-height:1.55}.ees-security svg{width:17px;height:17px;flex:0 0 auto;color:var(--gold);margin-top:1px}.ees-help-row{margin-top:28px;display:flex;align-items:center;justify-content:space-between;gap:16px;color:#81766e;font-size:11px}.ees-report{border:0;background:transparent;padding:0;color:var(--wine);cursor:pointer;font-size:11px;font-weight:750;border-bottom:1px solid rgba(52,25,31,.22)}@media(max-width:900px){.ees-page{grid-template-columns:1fr}.ees-brand-panel{display:none}.ees-login-side{min-height:100vh;padding:30px 22px 40px;align-items:start}.ees-login-wrap{width:min(520px,100%);margin:0 auto}.ees-mobile-brand{display:flex;color:var(--wine);margin-bottom:62px}.ees-mobile-brand .ees-monogram{border-color:rgba(52,25,31,.45);color:var(--wine)}.ees-mobile-brand .ees-brand-copy small{color:var(--gold)}}@media(max-width:520px){.ees-login-heading h2{font-size:42px}.ees-mobile-brand{margin-bottom:48px}.ees-help-row{align-items:flex-start;flex-direction:column}.ees-login-side{padding-inline:18px}}
            `}</style>
            <main className="ees-page">
                <section className="ees-brand-panel" aria-label="Expat Elite Singles">
                    <div className="ees-brand"><div className="ees-monogram">E<span>E</span>S</div><div className="ees-brand-copy"><strong>Expat Elite</strong><small>Singles</small></div></div>
                    <div className="ees-brand-body"><p className="ees-eyebrow">Private · International · Intentional</p><h1>Welcome back to a more <em>considered connection.</em></h1><p>A discreet member experience for accomplished singles and expatriates who value substance, privacy and genuine long-term compatibility.</p></div>
                    <div className="ees-principles" aria-label="Platform principles"><span><i></i>Private by design</span><span><i></i>Curated experience</span><span><i></i>Meaningful introductions</span></div>
                </section>
                <section className="ees-login-side">
                    <div className="ees-login-wrap">
                        <div className="ees-brand ees-mobile-brand"><div className="ees-monogram">E<span>E</span>S</div><div className="ees-brand-copy"><strong>Expat Elite</strong><small>Singles</small></div></div>
                        <header className="ees-login-heading"><p className="ees-eyebrow">Member access</p><h2>Sign in.</h2><p>Continue to your private Expat Elite Singles account.</p></header>
                        <motion.form className="ees-form" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{duration:1}} onSubmit={handleSubmit}>
                            <div className="ees-field"><label className="ees-label" htmlFor="ees-email">Email address</label><div className="ees-input-shell"><input id="ees-email" className="ees-input" name="email" type="email" autoComplete="email" placeholder="you@example.com" required onFocus={() => trackEvent('login_email_input')} onChange={(e) => setField(e.target.value, "EMAIL")}/></div></div>
                            <div className="ees-field"><div className="ees-field-row"><label className="ees-label" htmlFor="ees-password">Password</label><Link to='/forgottenpassword' onClick={() => trackEvent('login_forgot_password_clicked')} className="ees-forgot">Forgot password?</Link></div><div className="ees-input-shell"><input id="ees-password" className="ees-input ees-password" name="password" type={showPassword ? 'text' : 'password'} autoComplete="current-password" placeholder="Enter your password" required onFocus={() => trackEvent('login_password_input')} onChange={(e) => setField(e.target.value, "password")}/><button className="ees-eye" type="button" aria-label={showPassword ? 'Hide password' : 'Show password'} onClick={() => setShowPassword(!showPassword)}><svg viewBox="0 0 24 24" width="19" height="19" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true"><path d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6Z"/><circle cx="12" cy="12" r="2.8"/></svg></button></div></div>
                            <button className="ees-login-btn" type="submit">Log in</button>
                            <div className="ees-divider">or continue with</div>
                            <div className="ees-google-wrap"><GoogleLogin onSuccess={handleSuccess} onError={handleError} width="360" /></div>
                        </motion.form>
                        <div className="ees-security"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true"><path d="M7 10V7a5 5 0 0 1 10 0v3"/><rect x="4.5" y="10" width="15" height="10" rx="2"/><path d="M12 14v2.5"/></svg><span>Your account access is private. Never share your password or verification details with anyone.</span></div>
                        <div className="ees-help-row"><span>Need help accessing your account?</span><button className="ees-report" type="button" onClick={() => window.customAlert ? window.customAlert('Please contact support with the issue you are seeing.') : alert('Please contact support with the issue you are seeing.')}>Report an issue</button></div>
                    </div>
                </section>
            </main>
        </div>
        </>
    )
}

export function SirriEnabledLogin(props) {
    const [allanswers, setAllAnswers] = React.useState(fillerprofiledata())
    const [showExpiredAccountModal, setShowExpiredAccountModal] = React.useState(false)
    const [pendingEmail, setPendingEmail] = React.useState('')
    const [pendingAuthCookie, setPendingAuthCookie] = React.useState('')
    const [isSecurityStep, setIsSecurityStep] = React.useState(false)
    const [securityAnswer, setSecurityAnswer] = React.useState('')
    const [loginVerified, setLoginVerified] = React.useState(false)

    function resetSecurityStep() {
        setIsSecurityStep(false)
        setSecurityAnswer('')
        setPendingEmail('')
        setPendingAuthCookie('')
        setLoginVerified(false)
    }

    function finalizeLogin(email) {
        if (!email) {
            alert('Unable to determine your account. Please try logging in again.')
            resetSecurityStep()
            return
        }
        setLoginCookies(email, pendingAuthCookie)
        trackEvent('login_success', { user: email })
        const params = new URLSearchParams(window.location.search)
        const redirectTarget = params.get('redirect') || '/sirri_api/activations'
        const isSafeAdminRedirect = redirectTarget.startsWith('/sirri_api/') && !redirectTarget.startsWith('//')
        window.location.assign(isSafeAdminRedirect ? redirectTarget : '/sirri_api/activations')
    }

    const handleSuccess = (credentialResponse) => {
        trackEvent('login_google_success')
        const url = "/api/googleauth"
        console.log("Here:", credentialResponse);
        const decryptedjwt = jwtDecode(credentialResponse.credential)
        console.log("Decrypted:", decryptedjwt)
        const formData = new FormData();
        for (var key in decryptedjwt) {
            formData.append(key, decryptedjwt[key]) 
        }
        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            },
        };
        console.log(formData)
        postData(url, formData, config).then((data) => {
            console.log(data);
            if (data.responsecode === 200) {
                const email = allanswers['EMAIL'] || decryptedjwt.email || ''
                setPendingEmail(email)
                setPendingAuthCookie(data.auth_cookie || '')
                setSecurityAnswer('')
                setIsSecurityStep(true)
                setLoginVerified(true)
            } else if (isExpiredAccountLoginResponse(data)) {
                trackEvent('login_failed', { reason: 'account_expired' })
                setShowExpiredAccountModal(true)
            } else if (data.responsecode === 404) {
                trackEvent('login_failed', { reason: 'email_invalid' })
                const message = (data && data.message) ? data.message : "Your email is invalid."
                alert(message)
            } else if (data.responsecode === 503) {
                alert("The site is currently under maintenance.")
            } else {
                alert("Something went wrong. Please contact support.")
            }
        }).catch((error) => {
            console.error("Error fetching purgatory data:", error);
            throw error;
        });
    };
    
    
    const handleError = () => {
        trackEvent('login_google_failed')
        console.log('Login Failed');
    };

    function setField(value, field) {
        var currentanswers = allanswers;
        console.log("Newthing ", currentanswers);
        currentanswers[field] = value
        setAllAnswers(currentanswers)
        console.log(allanswers)
    }

    function handleSubmit(event) {
        if (event) event.preventDefault()
        trackEvent(isSecurityStep ? 'login_security_answer_submit_pressed' : 'login_submit_pressed')
        if (isSecurityStep) {
            if (!loginVerified) {
                alert('Your login session has expired. Please log in again.')
                resetSecurityStep()
                return
            }

            const email = (pendingEmail || allanswers['EMAIL'] || '').trim()

            if (!email) {
                alert('We could not verify your email. Please restart the login process.')
                resetSecurityStep()
                return
            }

            const formData = new FormData()
            formData.append('EMAIL', email)
            formData.append('answer', securityAnswer)

            const config = {
                headers: {
                    'content-type': 'multipart/form-data',
                },
            }

            postData('/api/security-answer', formData, config).then((data) => {
                if (data.responsecode === 200) {
                    trackEvent('login_security_answer_success')
                    finalizeLogin(email)
                } else if (data.responsecode === 401) {
                    trackEvent('login_security_answer_failed')
                    alert('Incorrect answer. Please try again.')
                    setSecurityAnswer('')
                } else if (data.responsecode === 404) {
                    alert('Your account could not be located. Please try logging in again.')
                    resetSecurityStep()
                } else if (data.message) {
                    alert(data.message)
                } else {
                    alert('Unable to verify your answer. Please try again later.')
                }
            }).catch((error) => {
                console.error('Error verifying security answer:', error)
                alert('Unable to verify your answer. Please try again later.')
            })

            return
        }
        const url = props.url;
        const formData = new FormData();
        for (var key in allanswers) {
            formData.append(key, allanswers[key])
        }
        
        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            },
        };
        console.log(formData)
        postData(url, formData, config).then((data) => {
            console.log(data);
            if (data.responsecode === 200) {
                trackEvent('login_security_question_shown')
                setPendingEmail(allanswers['EMAIL'])
                setPendingAuthCookie(data.auth_cookie || '')
                setSecurityAnswer('')
                setIsSecurityStep(true)
                setLoginVerified(true)
            } else if (isExpiredAccountLoginResponse(data)) {
                trackEvent('login_failed', { reason: 'account_expired' })
                setShowExpiredAccountModal(true)
            } else if (data.responsecode === 404) {
                const message = (data && data.message) ? data.message : "Your email is invalid."
                alert(message)
            } else if (data.responsecode === 403) {
                alert("Your password is incorrect. You can click forgot password if you've forgotten it. Otherwise, please try again.")
            } else if (data.responsecode === 503) {
                alert("The site is currently under maintenance.")
            } else {
                alert("Something went wrong. Please contact support.")
                resetSecurityStep()
            }
        }).catch((error) => {
            console.error("Error fetching purgatory data:", error);
            throw error;
        });

    }
    return (
        <>
        <ExpiredAccountModal show={showExpiredAccountModal} onClose={() => setShowExpiredAccountModal(false)} />
        <div className="league-spartan mb-3 min-h-screen flex flex-col justify-center md:justify-start">
            <motion.form
                className="flex flex-col"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{duration:1}}
                onSubmit={handleSubmit}
              >
                {isSecurityStep
                    ? <>
                        <p className="text-white text-center my-2">Security question: "The traveller"</p>
                        <input
                            className="bg-white text-black placeholder-gray-600 p-2 my-2 rounded-full"
                            placeholder='Answer:'
                            value={securityAnswer}
                            onChange={(e) => setSecurityAnswer(e.target.value)}
                        />
                        <button type='submit' className="w-full text-black bg-white p-2 my-3 rounded-full">VERIFY ANSWER</button>
                        <button
                            type='button'
                            className="w-full text-black bg-white p-1 my-1 rounded-full text-xs"
                            onClick={() => resetSecurityStep()}
                        >START OVER</button>
                    </>
                    : <>
                        <input className="bg-white text-black placeholder-gray-600 p-2 my-2 rounded-full" placeholder='Email:' onFocus={() => trackEvent('login_email_input')} onChange={(e) => setField(e.target.value, "EMAIL")}/>
                        <PasswordInput setValue={(value) => setField(value, "password")} />

                        <button type='submit' className="w-full text-black bg-white p-2 my-3 rounded-full">LOGIN</button>
                        <Link to='/forgottenpassword' onClick={() => trackEvent('login_forgot_password_clicked')} className="w-full text-black text-xs bg-white p-1 my-1 rounded-full">FORGOT PASSWORD</Link>
                    </>
                }
            </motion.form>
        </div>
        </>
    )
}

export function Resettingpassword(props) {
    const { token } = useParams()
    const [allanswers, setAllAnswers] = React.useState({})
    let navigate = useNavigate();
    
    function setField(value, field) {
        var currentanswers = allanswers;
        console.log("Newthing ", currentanswers);
        currentanswers[field] = value
        setAllAnswers(currentanswers)
        console.log(allanswers)
    }

    function handleSubmit(event) {
        if (event) event.preventDefault()
        trackEvent('reset_password_submit_pressed')
        const url = props.url;
        if (allanswers["password"] !== allanswers["confirmpassword"]) {
            trackEvent('reset_password_failed', { reason: 'password_mismatch' })
            alert("Passwords do not match.")
            return
        }
        const formData = new FormData();
        formData.append('token', token)
        
        for (var key in allanswers) {
            formData.append(key, allanswers[key]) 
        }
        
        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            },
        };
        console.log(formData)
        
        postData(url, formData, config).then((data) => {
            console.log(data);
            if (data.responsecode === 200) {
                trackEvent('reset_password_success')
                navigate('/resetpasswordsuccess')
            } else {
                trackEvent('reset_password_failed')
                alert("Something went wrong. Please contact support.")
            }
        }).catch((error) => {
            console.error("Error fetching purgatory data:", error);
            throw error;
        });

    }
    return (
        <div className="league-spartan mb-3 min-h-screen flex flex-col justify-center md:justify-start">
            <motion.form
                className="flex flex-col"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{duration:1}}
              >
                <input className="bg-white text-black placeholder-gray-600 p-2 my-2 rounded-full" placeholder='Password:' type='password' onChange={(e) => setField(e.target.value, "password")}/>
                <input className="bg-white text-black placeholder-gray-600 p-2 my-2 rounded-full" placeholder='Confirm Password:' type='password' onChange={(e) => setField(e.target.value, "confirmpassword")}/>

                <button type='button' onClick={() => handleSubmit()} className="w-full text-black bg-white p-2 my-3 rounded-full">RESET PASSWORD</button>
            </motion.form>
        </div>
    )
}

export function ForgotPassword(props) {
    const [allanswers, setAllAnswers] = React.useState(fillerprofiledata())
    let navigate = useNavigate();

    React.useEffect(() => {
        trackEvent('forgot_password_page_visit');
    }, []);

    function setField(value, field) {
        var currentanswers = allanswers;
        console.log("Newthing ", currentanswers);
        currentanswers[field] = value
        setAllAnswers(currentanswers)
        console.log(allanswers)
    }

    function handleSubmit(event) {
        if (event) event.preventDefault()
        trackEvent('forgot_password_submit_pressed')
        const url = props.url;
        const formData = new FormData();
        for (var key in allanswers) {
            formData.append(key, allanswers[key]) 
        }
        
        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            },
        };
        
        console.log(formData)
        postData(url, formData, config).then((data) => {
            console.log(data);
            if (data.responsecode === 200) {
                trackEvent('forgot_password_submit_success')
                navigate('/forgottenpasswordsubmitted')
            } else {
                trackEvent('forgot_password_submit_failed')
                alert("Something went wrong. Please contact support.")
            }
        }).catch((error) => {
            console.error("Error fetching purgatory data:", error);
            throw error;
        });

    }

    const hostname = window.location.hostname || "";
    const isUpendoHalisi = /(^|\.)upendo-halisi\.com$/i.test(hostname)
    const isPenziHalisi = hostname.includes("penzi-halisi.com")

    if (isUpendoHalisi || isPenziHalisi) {
        const siteTheme = isUpendoHalisi
            ? {
                key: 'uh',
                name: 'Upendo Halisi',
                kicker: 'Meet someone worth knowing',
                title: 'Reset your Upendo Halisi password.',
                subtitle: 'Enter your account email and we will send a private reset link so you can return safely.',
                logo: '/assets/img/uhlogo.jpeg',
                accent: 'Private · warm · protected',
                note: 'Use the email connected to your Upendo Halisi account.',
            }
            : {
                key: 'ph',
                name: 'Penzi Halisi',
                kicker: 'Genuine connections',
                title: 'Reset your Penzi Halisi password.',
                subtitle: 'Enter your account email and we will send a secure reset link for your private account.',
                logo: '/assets/img/phlogo.jpeg',
                accent: 'Secure · focused · verified',
                note: 'Use the email connected to your Penzi Halisi account.',
            }

        return (
            <div className={`halisi-forgot-page ${siteTheme.key}-forgot-page`}>
                <style>{`
                    .halisi-forgot-page{--navy:#041535;--navy-2:#082b68;--gold:#e3b94d;--gold-2:#ffd978;--ink:#0d2146;--pink:#ff58cf;--pink-2:#ff89dd;--line:rgba(211,166,53,.28);--shadow:0 35px 90px rgba(0,0,0,.35);position:fixed;inset:0;z-index:20;min-height:100vh;overflow:auto;overflow-x:hidden;text-transform:none;font-family:Inter,ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;color:var(--ink);background:radial-gradient(circle at 20% 4%,rgba(35,91,177,.52),transparent 25%),radial-gradient(circle at 92% 14%,rgba(223,176,56,.12),transparent 20%),linear-gradient(145deg,#03122d 0%,#082a66 47%,#020d21 100%)}
                    .uh-forgot-page{--line:rgba(216,180,90,.24);--shadow:0 35px 90px rgba(0,0,0,.52);color:#fff;background:radial-gradient(circle at 50% -10%,rgba(255,88,207,.13),transparent 28%),radial-gradient(circle at 15% 18%,rgba(216,180,90,.09),transparent 24%),#050505}.halisi-forgot-page *,.halisi-forgot-page *:before,.halisi-forgot-page *:after{box-sizing:border-box}
                    .halisi-forgot-page:before{content:"";position:fixed;inset:0;pointer-events:none;opacity:.18;background-image:linear-gradient(rgba(255,255,255,.025) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,.025) 1px,transparent 1px);background-size:38px 38px;mask-image:linear-gradient(to bottom,#000,transparent 72%)}
                    .halisi-forgot-shell{width:min(1120px,calc(100% - 34px));max-width:100vw;min-height:100vh;margin:0 auto;padding:28px 0 54px;display:flex;align-items:center;justify-content:center;position:relative}.halisi-forgot-card{width:100%;display:grid;grid-template-columns:minmax(330px,.94fr) minmax(360px,1.06fr);overflow:hidden;border-radius:30px;border:1px solid rgba(255,218,111,.52);background:rgba(255,255,255,.99);box-shadow:var(--shadow)}.halisi-forgot-card>*{min-width:0}.uh-forgot-page .halisi-forgot-card{border-color:var(--line);background:linear-gradient(180deg,rgba(255,255,255,.035),rgba(255,255,255,.012));backdrop-filter:blur(8px)}
                    .halisi-forgot-brand-panel{position:relative;min-height:620px;padding:42px clamp(28px,5vw,64px);display:flex;flex-direction:column;justify-content:space-between;color:white;background:linear-gradient(145deg,#041535,#082a66 58%,#020d21);isolation:isolate;overflow:hidden}.uh-forgot-page .halisi-forgot-brand-panel{background:linear-gradient(145deg,#050505,#101010 58%,#050505)}.halisi-forgot-brand-panel:before{content:"";position:absolute;width:520px;height:520px;border:1px solid rgba(255,217,120,.18);border-radius:50%;right:-260px;top:-150px;box-shadow:0 0 0 46px rgba(255,217,120,.025),0 0 0 92px rgba(255,217,120,.016);z-index:-1}.uh-forgot-page .halisi-forgot-brand-panel:before{border-color:rgba(255,88,207,.20);box-shadow:0 0 0 46px rgba(255,88,207,.025),0 0 0 92px rgba(216,180,90,.02)}
                    .halisi-forgot-brand{display:flex;align-items:center;gap:16px;text-decoration:none;color:inherit}.halisi-forgot-logo{width:84px;height:84px;border-radius:24px;overflow:hidden;border:1px solid rgba(255,219,120,.82);background:rgba(255,255,255,.04);box-shadow:0 18px 46px rgba(0,0,0,.34),0 0 34px rgba(227,185,77,.10)}.uh-forgot-page .halisi-forgot-logo{border-radius:50%;border-color:rgba(216,180,90,.65)}.halisi-forgot-logo img{width:100%;height:100%;object-fit:cover}.uh-forgot-page .halisi-forgot-logo img{object-fit:contain}.halisi-forgot-brand-copy{display:grid;gap:5px;line-height:1.05}.halisi-forgot-brand-copy small{color:var(--gold-2);font-weight:850;letter-spacing:.22em;text-transform:uppercase;font-size:.70rem}.uh-forgot-page .halisi-forgot-brand-copy small{color:#f0d88c}.halisi-forgot-brand-copy strong{color:white;font-family:Georgia,"Times New Roman",serif;font-size:clamp(1.35rem,2.2vw,2rem);font-weight:500}.uh-forgot-page .halisi-forgot-brand-copy strong{color:var(--pink-2)}
                    .halisi-forgot-copy{max-width:100%;padding:70px 0 52px}.halisi-forgot-eyebrow{margin:0 0 18px;color:var(--gold-2);text-transform:uppercase;letter-spacing:.20em;font-size:.72rem;font-weight:900}.halisi-forgot-copy h1{margin:0;color:white;font-family:Georgia,"Times New Roman",serif;font-weight:500;font-size:clamp(2.15rem,3.55vw,3.9rem);line-height:1.02;letter-spacing:-.035em;overflow-wrap:break-word}.uh-forgot-page .halisi-forgot-copy h1{font-family:Inter,ui-sans-serif,system-ui,sans-serif;font-weight:850;letter-spacing:-.05em}.halisi-forgot-copy h1 em{display:block;margin-top:10px;color:var(--gold-2);font-style:normal}.uh-forgot-page .halisi-forgot-copy h1 em{color:var(--pink-2)}.halisi-forgot-copy p:not(.halisi-forgot-eyebrow){margin:22px 0 0;color:rgba(255,255,255,.74);font-size:1rem;line-height:1.72;max-width:500px}
                    .halisi-forgot-form-side{min-width:0;width:100%;min-height:620px;display:grid;place-items:center;padding:44px clamp(28px,5vw,78px);background:linear-gradient(180deg,#fffefa,#fff9ed);position:relative}.uh-forgot-page .halisi-forgot-form-side{background:linear-gradient(180deg,rgba(255,255,255,.055),rgba(255,255,255,.025));color:white}.halisi-forgot-form-side:before{content:"";position:absolute;top:0;left:0;right:0;height:4px;background:linear-gradient(90deg,var(--navy),var(--gold-2),var(--navy))}.uh-forgot-page .halisi-forgot-form-side:before{background:linear-gradient(90deg,var(--pink),var(--gold),var(--pink))}.halisi-forgot-wrap{width:min(470px,100%);max-width:100%;min-width:0}.halisi-forgot-mobile-brand{display:none}.halisi-forgot-heading{margin-bottom:32px}.halisi-forgot-heading .halisi-forgot-eyebrow{color:#aa7a19;margin-bottom:14px}.uh-forgot-page .halisi-forgot-heading .halisi-forgot-eyebrow{color:#f0d88c}.halisi-forgot-heading h2{margin:0;font-family:Georgia,"Times New Roman",serif;font-weight:500;color:#09265d;font-size:clamp(2.25rem,4vw,3.3rem);letter-spacing:-.035em;line-height:1}.uh-forgot-page .halisi-forgot-heading h2{font-family:Inter,ui-sans-serif,system-ui,sans-serif;font-weight:850;color:var(--pink-2);letter-spacing:-.045em}.halisi-forgot-heading p:not(.halisi-forgot-eyebrow){margin:14px 0 0;color:#6d7280;font-size:.95rem;line-height:1.65}.uh-forgot-page .halisi-forgot-heading p:not(.halisi-forgot-eyebrow){color:rgba(255,255,255,.62)}
                    .halisi-forgot-form{display:grid;gap:20px}.halisi-forgot-field{display:grid;gap:8px}.halisi-forgot-label{font-size:.70rem;font-weight:900;text-transform:uppercase;letter-spacing:.12em;color:#5d5047}.uh-forgot-page .halisi-forgot-label{color:rgba(255,255,255,.76)}.halisi-forgot-input{display:block;width:100%;max-width:100%;height:58px;border:1px solid rgba(9,38,93,.14);border-radius:16px;background:rgba(255,255,255,.90);color:#071b45;padding:0 18px;outline:0;box-shadow:0 1px 0 rgba(255,255,255,.75) inset;transition:border-color .2s ease,box-shadow .2s ease,background .2s ease}.uh-forgot-page .halisi-forgot-input{border-color:rgba(216,180,90,.24);background:rgba(255,255,255,.08);color:white;box-shadow:inset 0 1px 0 rgba(255,255,255,.05)}.halisi-forgot-input::placeholder{color:#9aa2ad}.uh-forgot-page .halisi-forgot-input::placeholder{color:rgba(255,255,255,.45)}.halisi-forgot-input:focus{border-color:var(--gold);background:#fff;box-shadow:0 0 0 4px rgba(227,185,77,.14)}.uh-forgot-page .halisi-forgot-input:focus{border-color:var(--pink-2);background:rgba(255,255,255,.12);box-shadow:0 0 0 4px rgba(255,88,207,.10)}
                    .halisi-forgot-btn{width:100%;max-width:100%;height:60px;border:0;border-radius:18px;background:linear-gradient(135deg,#ffe58b 0%,#f7c84f 48%,#c98c1d 100%);color:#071b45;font-weight:950;text-transform:uppercase;letter-spacing:.09em;box-shadow:0 18px 35px rgba(201,140,29,.24);cursor:pointer;transition:transform .2s ease,filter .2s ease}.uh-forgot-page .halisi-forgot-btn{background:linear-gradient(135deg,var(--pink),var(--pink-2) 52%,var(--gold));color:#050505}.halisi-forgot-btn:hover{transform:translateY(-2px);filter:brightness(1.04)}.halisi-forgot-note{margin:22px 0 0;border:1px solid rgba(9,38,93,.10);border-radius:18px;background:rgba(255,255,255,.58);padding:13px 14px;color:#5b6472;font-size:.82rem;line-height:1.45}.uh-forgot-page .halisi-forgot-note{border-color:rgba(216,180,90,.18);background:rgba(255,255,255,.055);color:rgba(255,255,255,.62)}
                    @media(max-width:900px){.halisi-forgot-shell{width:100%;max-width:100vw;padding:0}.halisi-forgot-card{width:100%;max-width:100vw;grid-template-columns:minmax(0,1fr);border-radius:0;min-height:100vh}.halisi-forgot-brand-panel{display:none}.halisi-forgot-form-side{min-height:100vh;width:100%;max-width:100vw;padding:28px 16px}.halisi-forgot-mobile-brand{display:flex;margin-bottom:24px}.halisi-forgot-logo{width:78px;height:78px}.halisi-forgot-brand-copy small{letter-spacing:.16em}.halisi-forgot-heading{text-align:left}.halisi-forgot-heading h2{font-size:clamp(2rem,11vw,3rem)}.halisi-forgot-heading p:not(.halisi-forgot-eyebrow){font-size:.9rem;overflow-wrap:break-word}}
                `}</style>
                <main className="halisi-forgot-shell">
                    <section className="halisi-forgot-card" aria-label={`${siteTheme.name} password recovery`}>
                        <aside className="halisi-forgot-brand-panel">
                            <a className="halisi-forgot-brand" href="/" aria-label={`${siteTheme.name} home`}><span className="halisi-forgot-logo"><img src={siteTheme.logo} alt={`${siteTheme.name} logo`} /></span><span className="halisi-forgot-brand-copy"><small>{siteTheme.kicker}</small><strong>{siteTheme.name}</strong></span></a>
                            <div className="halisi-forgot-copy"><p className="halisi-forgot-eyebrow">Account recovery</p><h1>{siteTheme.title} <em>{siteTheme.accent}</em></h1><p>{siteTheme.subtitle}</p></div>
                        </aside>
                        <section className="halisi-forgot-form-side">
                            <div className="halisi-forgot-wrap">
                                <a className="halisi-forgot-brand halisi-forgot-mobile-brand" href="/" aria-label={`${siteTheme.name} home`}><span className="halisi-forgot-logo"><img src={siteTheme.logo} alt={`${siteTheme.name} logo`} /></span><span className="halisi-forgot-brand-copy"><small>{siteTheme.kicker}</small><strong>{siteTheme.name}</strong></span></a>
                                <header className="halisi-forgot-heading"><p className="halisi-forgot-eyebrow">Password reset</p><h2>Recover account.</h2><p>{siteTheme.note}</p></header>
                                <motion.form className="halisi-forgot-form" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{duration:1}} onSubmit={handleSubmit}>
                                    <div className="halisi-forgot-field"><label className="halisi-forgot-label" htmlFor="halisi-forgot-email">Email address</label><input id="halisi-forgot-email" className="halisi-forgot-input" type="email" autoComplete="email" placeholder="you@example.com" onFocus={() => trackEvent('forgot_password_email_input')} onChange={(e) => setField(e.target.value, "EMAIL")}/></div>
                                    <button type='submit' className="halisi-forgot-btn">Recover account</button>
                                </motion.form>
                                <p className="halisi-forgot-note">If the email is linked to an account, a reset link will be sent privately.</p>
                            </div>
                        </section>
                    </section>
                </main>
            </div>
        )
    }

    return (
        <div className="league-spartan mb-3 min-h-screen flex flex-col justify-center md:justify-start">
            <motion.form
                className="flex flex-col"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{duration:1}}
                onSubmit={handleSubmit}
              >
                <input className="bg-white text-black placeholder-gray-600 p-2 my-2 rounded-full" placeholder='Email:' onFocus={() => trackEvent('forgot_password_email_input')} onChange={(e) => setField(e.target.value, "EMAIL")}/>

                <button type='submit' className="w-full text-black bg-white p-2 my-2 rounded-full">RECOVER ACCOUNT</button>
              </motion.form>
        </div>
    )
}

function Individual(props) {
    const [showallinfo, setShowAllInfo] = React.useState(false);
    const [thepackage, setPackage] = React.useState(props.item.package1)
    const [showEditModal, setShowEditModal] = React.useState(false)
    const [showMenu, setShowMenu] = React.useState(false)
    const {
        editableFields,
        fieldValue,
        handleEditSubmit,
        handleFieldChange,
        handleValueChange,
        isSubmitting,
        openEditModal,
        selectedField,
        setShowEditModal: setShowEditDataModal,
        showEditModal: showEditDataModal,
    } = useProfileFieldEditor(props.item, () => {
        window.location.reload()
    })

    function handleSubmit() {
        var formdata = new FormData()
        formdata.append('EMAIL', props.item.fullname1)
        formdata.append('package', thepackage)
        
        const url = "/api/sirri_api/change_package"
        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            },
        };
        postData(url, formdata, config).then((data) => {
            console.log(data);
            if (data.responsecode === 200) {
                alert("Package changed.")
                window.location.reload()
            } 
        }).catch((error) => {
            console.error("Error fetching purgatory data:", error);
            throw error;
        });
    }

    function handleArchive() {
        var formdata = new FormData()
        formdata.append('EMAIL', props.item.fullname1)
        
        const url = "/api/sirri_api/archive_via_name"
        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            },
        };
        
        postData(url, formdata, config).then((data) => {
            console.log(data);
            if (data.responsecode === 200) {
                alert("Archived.")
                window.location.reload()
            } 
        }).catch((error) => {
            console.error("Error fetching purgatory data:", error);
            throw error;
        });
    }

    function handlePhotoDelete() {
        var formdata = new FormData()
        formdata.append('EMAIL', props.item.fullname1)
        
        const url = "/api/sirri_api/delete_via_name"
        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            },
        };
        
        postData(url, formdata, config).then((data) => {
            console.log(data);
            if (data.responsecode === 200) {
                alert("Archived.")
                window.location.reload()
            } 
        }).catch((error) => {
            console.error("Error fetching purgatory data:", error);
            throw error;
        });
    }

    function handleSetVerifiedProfile() {
        const formdata = new FormData()
        formdata.append('_lookup_EMAIL', props.item.EMAIL || '')
        formdata.append('_lookup_fullname1', props.item.fullname1 || '')
        Object.keys(props.item).forEach((key) => {
            const value = props.item[key]
            if (value === undefined || value === null) {
                formdata.append(key, '')
            } else if (typeof value === 'object') {
                formdata.append(key, JSON.stringify(value))
            } else {
                formdata.append(key, value)
            }
        })
        formdata.set('verified_profile', true)

        postData('/api/edit_data', formdata, { headers: { 'content-type': 'multipart/form-data' } }).then((data) => {
            if (data.responsecode === 200) {
                alert('Profile marked as verified.')
                window.location.reload()
            } else {
                alert('Failed to mark profile as verified.')
            }
        }).catch((error) => {
            console.error('Error setting verified profile:', error)
            alert('Failed to mark profile as verified.')
        })
    }

    const isVerifiedProfile = props.item.verified_profile === true || props.item.verified_profile === 'true'

    return (
        <div className="mt-3 w-full flex flex-col justify-center items-center border border-white border-1 rounded-lg p-3">
            <SmartImageComponent
                src={'/api/profilepic/1?EMAIL='+props.item.EMAIL}
                backupurl={'/api/profilepic/1?EMAIL='+props.item.EMAIL}
                backup={true}
                id={generateUUID()}
                imageobjectcss={{}}
            />
            <div className="relative w-full rounded-md border border-white/20 bg-black/30 px-3 py-2 mb-2">
                <button className="absolute top-2 right-2 text-white" onClick={() => setShowMenu(!showMenu)} aria-label="Open profile actions"><MoreVertical size={20} /></button>
                <div className="pr-8 text-center">
                    <p className="text-white text-xs mb-1">
                        {props.item.fullname1}
                        {isVerifiedProfile ? <span className="ml-2 rounded-full bg-emerald-600 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-white">Verified</span> : null}
                    </p>
                    {props.item.thechats === undefined ? null
                        : <>
                            <p className="text-white text-xs mb-1">{props.item.thechats} chats</p>
                            <p className="text-white text-xs mb-1">Age: {props.item.age1}</p>
                            <p className="text-white text-xs mb-1">Nationality: {props.item.ethnicity1}</p>
                          </>
                    }
                </div>

                {showMenu && (
                    <div className="absolute right-2 top-9 bg-white text-black rounded shadow-md z-10 flex flex-col p-2 min-w-[190px]">
                        <div className='grid grid-cols-2 gap-1 mt-1'>
                            <select onChange={(e) => setPackage(e.target.value)} className="text-white border-white border-1 p-3 bg-black rounded-md text-xs w-full my-1">
                                <option>{props.item.package1}</option>
                                {packages.map((item, index) => <option key={index}>{item}</option>)}
                            </select>
                            <button onClick={() => {handleSubmit(); setShowMenu(false);}} className="text-white border-white border-1 p-3 bg-black rounded-md text-xs w-full my-1">Submit</button>
                        </div>
                        <Link className="p-1 text-left hover:bg-gray-200" onClick={() => setShowMenu(false)} to={"/profilen/"+Base64.encode(props.item.fullname1)}>Visit Profile</Link>
                        <button className="p-1 text-left hover:bg-gray-200" onClick={() => {setShowEditModal(true); setShowMenu(false);}}>Edit Profile</button>
                        <button className="p-1 text-left hover:bg-gray-200" onClick={() => {openEditModal(); setShowMenu(false);}}>Edit Data</button>
                        <button className="p-1 text-left hover:bg-gray-200" onClick={() => {handleSetVerifiedProfile(); setShowMenu(false);}} disabled={isVerifiedProfile}>{isVerifiedProfile ? 'Verified Profile' : 'Set as verified'}</button>
                        <ImageFormComponent EMAIL={props.item.EMAIL} id={generateUUID()} fullname1={props.item.fullname1} allanswers={props.item} gender={"Male"}/>
                        <button onClick={() => {handleArchive(); setShowMenu(false);}} className="text-white border-white border-1 p-3 bg-black rounded-md text-xs w-full my-1">Archive</button>
                        <button onClick={() => {handlePhotoDelete(); setShowMenu(false);}} className="text-white border-white border-1 p-3 bg-black rounded-md text-xs w-full my-1">Delete Photo</button>
                    </div>
                )}
            </div>

            {showallinfo
                ? <>
                    {Object.keys(props.item).filter(function(indivkey) {
                        return ['__id', 'timestamp'].includes(indivkey) === false
                    }).map(function(item, index) {
                        const thequestion = displayQuestions.filter(function(question) {
                            return question.fieldid == item
                        });
                        if (thequestion.length > 0) {
                            return (
                                <div className="my-2" key={index}>
                                    <p className="text-white text-base">{thequestion[0].question}:</p>
                                    <p className="text-white text-base">{props.item[item]}</p>
                                </div>
                            )
                        } else {
                            return (
                                <div className="my-2" key={index}>
                                    <p className="text-white text-base">{item}:</p>
                                    <p className="text-white text-base">{props.item[item]}</p>
                                </div>
                            )
                        }
                    })}
                    <Link className="bg-green-800 text-white mt-2 p-2 text-center" to={'/profilen/'+Base64.encode(props.item.fullname1)}>VIEW PROFILE</Link>
                  </>  
                : null
            }
            <GeneralModal
                showModal={showEditModal}
                maintitle="Edit Profile"
                notdisableproceed={false}
                canceltext="Back"
                setShowModal={setShowEditModal}
            >
                <div className="w-full bg-black p-3 rounded-full">
                    <Signup
                        allquestions={malequestions}
                        url="/api/edit_data"
                        mensform={true}
                        allrequired={false}
                        og_data={props.item}
                        gender="Male"
                        edit={true}
                    />
                </div>
            </GeneralModal>
            <GeneralModal
                showModal={showEditDataModal}
                maintitle="Edit Individual Data"
                canceltext="Close"
                notdisableproceed={false}
                setShowModal={setShowEditDataModal}
            >
                <form className="flex flex-col" onSubmit={handleEditSubmit}>
                    <label className="text-white text-xs mb-1" htmlFor={`field-select-${props.item.EMAIL}-men-dashboard`}>Field</label>
                    {editableFields.length > 0
                        ? <select
                            id={`field-select-${props.item.EMAIL}-men-dashboard`}
                            className="border p-2 mb-2 text-black"
                            value={selectedField}
                            onChange={handleFieldChange}
                        >
                            {editableFields.map((field) => (
                                <option key={field} value={field}>{field}</option>
                            ))}
                        </select>
                        : <p className="text-white text-xs mb-2">No editable fields available.</p>
                    }
                    <label className="text-white text-xs mb-1" htmlFor={`field-value-${props.item.EMAIL}-men-dashboard`}>Value</label>
                    <textarea
                        id={`field-value-${props.item.EMAIL}-men-dashboard`}
                        className="border p-2 mb-2 text-black"
                        rows={4}
                        value={fieldValue}
                        onChange={handleValueChange}
                        disabled={editableFields.length === 0}
                    />
                    <button
                        type="submit"
                        className="bg-red-800 text-white p-2 rounded-md disabled:opacity-50"
                        disabled={isSubmitting || editableFields.length === 0}
                    >
                        {isSubmitting ? 'Saving...' : 'Save Changes'}
                    </button>
                </form>
            </GeneralModal>
        </div>
    )
}

export function WomenInfoPage() {
    const [menprofiles, setMenProfiles] = React.useState([])
    const [loading, setLoading] = React.useState(false)

    
    function load() {
        setLoading(true)
        fetchData("/api/sirri_api/get_women").then((data) => {
            console.log(data);
            if (data.responsecode === 200) {
                setMenProfiles(data.acc)
                setLoading(false)
            } 
        }).catch((error) => {
            console.error("Error fetching purgatory data:", error);
            throw error;
        });
    }

    React.useEffect(load, [])

    return (
        <div className="w-full">
            {loading
                ? <p className="text-base text-white">Loading</p>
                : <div className="w-full grid grid-cols-2">{menprofiles.sort((a, b) => b.timestamp - a.timestamp).map((item, index) => <Individual item={item} index={index}/>)}</div>
            }
        </div>
    )
}

export function MenSignupPage(props) {
    return (
        <div>
            <Signup 
                url="/api/sirri_api/store_data" 
                allquestions={props.questions}
                mensform={true}
                gender="Male"
            />
            
            <MenDashboard/>
        </div>
    )
}

export function MenDashboard(props) {
    const [search, setSearch] = React.useState("");
    const [selectedPackage, setSelectedPackage] = React.useState(null);
    const [selectedEthnicity, setSelectedEthnicity] = React.useState(null);
    const [selectedCountry, setSelectedCountry] = React.useState(null);
    const listing = useMenListing({search, package: selectedPackage, ethnicity: selectedEthnicity, country: selectedCountry});
    const loaderRef = useListingObserver(listing);
    const {ethnicities, countries} = listing.facets;
    function togglePackage(pkg) {setSelectedPackage(prev => prev === pkg ? null : pkg);}
    return (
        <div className="p-3 w-full flex flex-col justify-center items-center">
            <input className="bg-white text-black placeholder-gray-600 p-2 my-2 w-full rounded-full"
                placeholder="Search for a specific gentleman:" value={search} onChange={e => setSearch(e.target.value)} />
            <div className="grid grid-cols-3 gap-1 my-2">
                {packages.map(pkg => (
                    <button
                        key={pkg}
                        className={`px-4 py-2 rounded-full ${selectedPackage === pkg ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
                        onClick={() => togglePackage(pkg)}
                    >
                        {pkg}
                    </button>
                ))}
            </div>
            <div className="my-2">
                <select
                    className="p-2 rounded w-full text-black"
                    value={selectedEthnicity || ''}
                    onChange={e => setSelectedEthnicity(e.target.value || null)}
                >
                    <option value="">All Ethnicities</option>
                    {ethnicities.map((eth, idx) => (
                        <option key={eth} value={eth}>{eth}</option>
                    ))}
                </select>
            </div>
            <div className="my-2">
                <select
                    className="p-2 rounded w-full text-black"
                    value={selectedCountry || ''}
                    onChange={e => setSelectedCountry(e.target.value || null)}
                >
                    <option value="">All Countries</option>
                    {countries.map((ct, idx) => (
                        <option key={ct} value={ct}>{ct}</option>
                    ))}
                </select>
            </div>
            <p className="text-white">Total number of men in filter: {listing.total == null ? '—' : listing.total} · Loaded: {listing.profiles.length}</p>
            {listing.initialLoading && <Loader />}
            <div className="w-full grid grid-cols-1 md:grid-cols-4 gap-1">
                {listing.profiles.map((item, index) => <Individual key={menProfileKey(item)} item={item} index={index} allquestions={props.questions} />)}
            </div>
            {!listing.initialLoading && !listing.error && listing.total === 0 && <p className="text-white">No men found.</p>}
            {listing.loadingMore && <Loader />}
            {listing.error && <div role="alert" className="text-white">{listing.error} <button type="button" onClick={listing.retry}>Retry</button></div>}
            {listing.hasMore && !listing.error && <button type="button" disabled={listing.initialLoading || listing.loadingMore}
                className="my-2 px-4 py-2 bg-blue-500 text-white rounded" onClick={listing.loadMore}>Load more</button>}
            <div ref={loaderRef} aria-hidden="true" className="h-1 w-full" />
        </div>
    );
}

export function MensMessagingDashboard(props) {
    const [menprofiles, setMenProfiles] = React.useState([])
    const [search, setSearch] = React.useState("")
    const [loading, setLoading] = React.useState(false)
    const [limit, setLimit] = React.useState(20)

    
    function load() {
        setLoading(true)
        fetchData(`/api/sirri_api/get_men_messaging?limit=${limit}`).then((data) => {
            console.log(data);
            if (data.responsecode === 200) {
                setMenProfiles(data.acc)
                setLoading(false)
            } 
        }).catch((error) => {
            console.error("Error fetching purgatory data:", error);
            throw error;
        });
    }

    React.useEffect(load, [limit])

    function loadMore() {
        setLimit(prev => prev + 20)
    }

    return (
        <div>
            <input className="bg-white text-black placeholder-gray-600 p-2 my-2  w-full rounded-full" placeholder="Search for a specific gentleman:" onChange={(e) => setSearch(e.target.value)}/>
            {loading
                ? <Loader/>
                : <>
                    <div className="w-full grid grid-cols-2 md:grid-cols-5 gap-2">
                        {menprofiles.sort((a, b) => a.thechats - b.thechats).map(function(item, index){
                        if (item.fullname1) {
                            if (search==="") {
                                return (
                                    <Individual item={item} index={index} allquestions={props.questions}/>
                                )
                            } else {
                                if (item.fullname1.toLowerCase().includes(search.toLowerCase())) {
                                    return (
                                        <Individual item={item} index={index} allquestions={props.questions}/>
                                    )
                                }
                            }
                        }
                        })}
                    </div>
                    {menprofiles.length >= limit && (
                        <button className="my-2 px-4 py-2 bg-blue-500 text-white rounded" onClick={loadMore}>Load more</button>
                    )}
                </>
            }
        </div>
    )
}

function IndividualIndividual(props) {
    const [thepackage, setPackage] = React.useState(props.item.package1)
    const [showdiagnosticinfo, setShowDiagnosticInfo] = React.useState(false)
    const [showUpgradeModal, setShowUpgradeModal] = React.useState(false)
    const [showLivenessVideoModal, setShowLivenessVideoModal] = React.useState(false)
    const [showMenu, setShowMenu] = React.useState(false)
    const [showHideProfileModal, setShowHideProfileModal] = React.useState(false)
    const [menProfilesForHide, setMenProfilesForHide] = React.useState([])
    const [selectedHiddenProfileName, setSelectedHiddenProfileName] = React.useState('')
    const [menProfilesLoading, setMenProfilesLoading] = React.useState(false)
    const [hideProfileSubmitting, setHideProfileSubmitting] = React.useState(false)
    const [imageVersion, setImageVersion] = React.useState(Date.now())
    const {
        editableFields,
        fieldValue,
        handleEditSubmit,
        handleFieldChange,
        handleValueChange,
        isSubmitting,
        openEditModal,
        selectedField,
        setShowEditModal,
        showEditModal,
    } = useProfileFieldEditor(props.item, () => {
        if (props.reload) props.reload()
    })

    function handleOpenEdit() {
        if (openEditModal()) {
            setShowMenu(false)
        }
    }
    
    function submitProfileUpdate(updated, successMessage) {
        const formdata = new FormData()
        formdata.append('_lookup_EMAIL', props.item.EMAIL || '')
        formdata.append('_lookup_fullname1', props.item.fullname1 || '')
        for (const key in updated) {
            formdata.append(key, updated[key])
        }

        const url = '/api/edit_data'
        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            },
        }

        postData(url, formdata, config).then((data) => {
            if (data.responsecode === 200) {
                alert(successMessage)
                props.reload()
                setShowMenu(false)
            }
        }).catch((err) => {
            console.log('Error updating profile: ', err)
        })
    }

    function handleSetFullname() {
        const newName = window.prompt('Enter new fullname:', props.item.fullname1)
        if (!newName) return

        const updated = { ...props.item }
        updated.fullname1 = newName
        const parts = newName.trim().split(' ')
        updated.firstname1 = parts[0] || ''
        updated.middlename1 = parts[1] || ''
        updated.lastname1 = parts[2] || ''

        submitProfileUpdate(updated, 'Name updated.')
    }

    function handleSetVerifiedProfile() {
        const updated = { ...props.item, verified_profile: true }
        submitProfileUpdate(updated, 'Profile marked as verified.')
    }

    async function handleSubmit(packagename) {
        let upgradeDetails = null;
        if (packagename !== props.item.package1) {
            upgradeDetails = await promptForUpgradeDetails(props.item);
            if (!upgradeDetails) {
                return;
            }
        }

        var formdata = new FormData()
        formdata.append('EMAIL', props.item.EMAIL)
        formdata.append('package', packagename)

        const url = "/api/sirri_api/change_package"
        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            },
        };
        postData(url, formdata, config).then((data) => {
            console.log(data);
            if (data.responsecode === 200) {
                alert("Package changed.")
                if (upgradeDetails) {
                    recordUpgrade(props.item, upgradeDetails.amount, upgradeDetails.date)
                }
                setPackage(packagename)
                props.reload()
                setShowMenu(false)
            }
        }).catch((err) => {
            console.log("Error in setProfiledataSubmit: ", err);
            throw err;
        });
    }

    function handleDenialOfService() {
        const shouldDenyService = !props.item.denialofservice
        const payload = {
            email: props.item.EMAIL,
            denialofservice: shouldDenyService,
        }

        postData('/api/maintenance/denial_of_service', payload).then((data) => {
            if (data.status === 'ok') {
                alert(shouldDenyService ? 'Service denied.' : 'Service allowed.')
                if (props.reload) props.reload()
            }
        }).catch((err) => {
            console.log('Error in handleDenialOfService: ', err)
            throw err
        })
    }

    function handleAutoMessage() {
        var formdata = new FormData()
        formdata.append('EMAIL', props.item.EMAIL)
        
        const url = "/api/sirri_api/auto_messages_email"
        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            },
        };
        
        postData(url, formdata, config).then((data) => {
            console.log(data);
            if (data.responsecode === 200) {
                alert(`Auto Messaged. Matches: ${data.matches.length}`);
            } 
        }).catch((error) => {
            console.error("Error fetching purgatory data:", error);
            throw error;
        });
    }

    function handleGenerateHubby() {
        const url = "/api/sirri_api/generate_hubby"
        const payload = { profile: props.item }

        postData(url, payload).then((data) => {
            if (data.responsecode === 200) {
                alert("Hubby generation requested.")
            } else {
                alert("Hubby generation failed.")
            }
        }).catch((error) => {
            console.error("Error generating hubby:", error)
            alert("Hubby generation failed.")
        }).finally(() => {
            setShowMenu(false)
        })
    }

    function getProfileDisplayName(profile) {
        const fullName = (profile.fullname1 || '').trim()
        if (fullName) return fullName

        const nameParts = [profile.firstname1, profile.middlename1, profile.lastname1]
            .filter(Boolean)
            .join(' ')
            .trim()
        return nameParts || profile.EMAIL || ''
    }

    function getHiddenProfiles() {
        const currentHiddenProfiles = props.item.hidden_profiles
        if (Array.isArray(currentHiddenProfiles)) {
            return currentHiddenProfiles
        }

        if (typeof currentHiddenProfiles === 'string' && currentHiddenProfiles.trim() !== '') {
            try {
                const parsedHiddenProfiles = JSON.parse(currentHiddenProfiles)
                if (Array.isArray(parsedHiddenProfiles)) {
                    return parsedHiddenProfiles
                }
            } catch (err) {
                console.warn('Could not parse hidden_profiles value:', err)
            }
        }

        return []
    }

    function loadMenProfilesForHide() {
        setMenProfilesLoading(true)
        fetchData('/api/sirri_api/get_men_normal?limit=10000').then((data) => {
            if (data.responsecode === 200) {
                const profiles = data.acc || []
                setMenProfilesForHide(profiles)
                if (!selectedHiddenProfileName && profiles.length > 0) {
                    setSelectedHiddenProfileName(getProfileDisplayName(profiles[0]))
                }
            }
        }).catch((error) => {
            console.error('Error loading men for hidden profile modal:', error)
            alert('Failed to load men profiles.')
        }).finally(() => {
            setMenProfilesLoading(false)
        })
    }

    function openHideProfileModal() {
        setShowMenu(false)
        setShowHideProfileModal(true)
        if (menProfilesForHide.length === 0) {
            loadMenProfilesForHide()
        }
    }

    const isVerifiedProfile = props.item.verified_profile === true || props.item.verified_profile === 'true'

    function handleAddHiddenProfile(e) {
        e.preventDefault()
        const selectedName = selectedHiddenProfileName.trim()
        if (!selectedName) {
            alert('Please select a profile to hide.')
            return
        }
        const hasMatchingProfile = menProfilesForHide.some((profile) => getProfileDisplayName(profile) === selectedName)
        if (!hasMatchingProfile) {
            alert('Please choose a valid profile from the list.')
            return
        }

        const hiddenProfiles = getHiddenProfiles()
        const updatedHiddenProfiles = hiddenProfiles.includes(selectedName)
            ? hiddenProfiles
            : [...hiddenProfiles, selectedName]

        setHideProfileSubmitting(true)
        postData('/api/edit_data_purgatory', {
            EMAIL: props.item.EMAIL,
            hidden_profiles: updatedHiddenProfiles,
        }).then((data) => {
            if (data.responsecode === 200) {
                alert(`${selectedName} added to hidden profiles.`)
                setShowHideProfileModal(false)
                if (props.reload) props.reload()
            } else {
                alert('Failed to update hidden profiles.')
            }
        }).catch((error) => {
            console.error('Error updating hidden profiles:', error)
            alert('Failed to update hidden profiles.')
        }).finally(() => {
            setHideProfileSubmitting(false)
        })
    }
    
    return (
        <div className={`relative mx-4 w-full flex flex-col justify-center items-center border border-1 rounded-sm p-3 ${Object.prototype.hasOwnProperty.call(props.item || {}, "ramzy") ? "bg-purple-800/40 border-purple-300" : (props.item.denialofservice ? "border-red-500 bg-red-900/20" : "border-white")}`}>
            <Link to={'/sirri_api/activation_profile/'+props.item.EMAIL} className="w-24 h-24 mb-2 rounded-full overflow-hidden block">
                <SmartImageComponent
                    cssclasses="object-cover w-full h-full"
                    src={'/api/profilepic/1?EMAIL='+props.item.EMAIL}
                    backupurl={'/api/profilepic/1?EMAIL='+props.item.EMAIL}
                    backup={true}
                    id={generateUUID()}
                />
            </Link>

            <div className="relative w-full rounded-md border border-white/20 bg-black/30 px-3 py-2 mb-2">
                <button className="absolute top-2 right-2 text-white" onClick={() => setShowMenu(!showMenu)} aria-label="Open profile actions"><MoreVertical size={20} /></button>
                {showMenu && (
                    <div className="absolute right-2 top-9 bg-white text-black rounded shadow-md z-10 flex flex-col p-2 min-w-[150px]">
                        <button className="p-1 text-left hover:bg-gray-200" onClick={() => {setShowDiagnosticInfo(!showdiagnosticinfo); setShowMenu(false);}}>{showdiagnosticinfo ? 'Hide Extra Info' : 'Show Extra Info'}</button>
                        <Link className="p-1 hover:bg-gray-200 text-left" onClick={() => setShowMenu(false)} to={'/profilen/'+Base64.encode(props.item.EMAIL)}>Profile</Link>
                        <Link className="p-1 hover:bg-gray-200 text-left" onClick={() => setShowMenu(false)} to={'/myprofilen/'+Base64.encode(props.item.EMAIL)}>As she sees it</Link>
                        <select
                            onChange={(e) => handleSubmit(e.target.value)}
                            className="border p-1 text-xs my-1"
                        >
                            <option>{props.item.package1}</option>
                            {packages.map((item, index) => <option key={index}>{item}</option>)}
                        </select>
                        <button className="p-1 text-left hover:bg-gray-200" onClick={() => {handleDenialOfService(); setShowMenu(false);}}>{props.item.denialofservice ? 'Allowal of Service' : 'Denial of Service'}</button>
                        <button className="p-1 text-left hover:bg-gray-200" onClick={() => {setShowUpgradeModal(true); setShowMenu(false);}}>Record Upgrade</button>
                        <button className="p-1 text-left hover:bg-gray-200" onClick={() => {handleAutoMessage(); setShowMenu(false);}}>Auto Messages</button>
                        <button className="p-1 text-left hover:bg-gray-200" onClick={handleGenerateHubby}>Generate Hubby</button>
                        {props.item.livenessVideoUrl
                            ? <button className="p-1 text-left hover:bg-gray-200" onClick={() => {setShowLivenessVideoModal(true); setShowMenu(false);}}>View Liveness Video</button>
                            : null
                        }
                        <button className="p-1 text-left hover:bg-gray-200" onClick={openHideProfileModal}>Hide Profile</button>
                        <button className="p-1 text-left hover:bg-gray-200" onClick={() => {setShowMenu(false); handleSetFullname();}}>Set Name</button>
                        <button className="p-1 text-left hover:bg-gray-200" onClick={handleSetVerifiedProfile} disabled={isVerifiedProfile}>{isVerifiedProfile ? 'Verified Profile' : 'Set as verified'}</button>
                        <button className="p-1 text-left hover:bg-gray-200" onClick={handleOpenEdit}>Edit Data</button>
                        <ImageFormComponent
                            EMAIL={props.item.EMAIL}
                            id={generateUUID()}
                            fullname1={props.item.fullname1}
                            allanswers={props.item}
                            gender={"Female"}
                            nextstep={() => {
                                if (props.reload) props.reload();
                                setImageVersion(Date.now());
                            }}
                        />
                    </div>
                )}
                <div className="pr-8 text-center">
                    <p className="text-white text-sm mb-1">
                        Name: {[props.item.firstname1, props.item.middlename1, props.item.lastname1].filter(Boolean).join(' ')} - {props.item.age1}
                        {isVerifiedProfile ? <span className="ml-2 rounded-full bg-emerald-600 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-white">Verified</span> : null}
                    </p>
                    <p className="text-white text-xs mb-1">EMAIL: {props.item.EMAIL}</p>
                    <p className="text-white text-xs mb-1">Occupation: {props.item.currentoccupation1}</p>
                    <p className="text-white text-xs mb-1">Package: {thepackage}</p>
                </div>
            </div>

            {showdiagnosticinfo
                ? <>
                    <p className="text-white text-xs mb-1">Phone: {props.item.phonenumber1}</p>

                    {props.item.last_messaged_timestamp !== undefined
                        ? <p className="text-white text-xs mb-1">Last message sent: {calculateDaysHoursMinutes(props.item.last_messaged_timestamp, Math.floor(Date.now() / 1000))}</p>
                        : <p className="text-white text-xs mb-1">Last message sent: Not tracking.</p>
                    }

                    {props.item.lastlogin !== undefined
                        ? <>
                            <p className="text-white text-xs mb-1">Last Login: {calculateDaysHoursMinutes(props.item.lastlogin, Math.floor(Date.now() / 1000))}</p>
                            <p className="text-white text-xs mb-1">Signup: {calculateDaysHoursMinutes(props.item.timestamp, Math.floor(Date.now() / 1000))}</p>
                        </>
                        : <>
                            <p className="text-white text-xs mb-1">Last Login: Not tracking.</p>
                            <p className="text-white text-xs mb-1">Signup: {calculateDaysHoursMinutes(props.item.timestamp, Math.floor(Date.now() / 1000))}</p>
                        </>
                    } 

                    {props.item.children1
                        ? <>
                            {props.item.children1 === "Yes"
                                ? <p className="text-white text-xs mb-1">Kids: {props.item.howmanychildren2}</p>  
                                : <p className="text-white text-xs mb-1">No kids.</p>  
                            }   
                        </>
                        : null
                    }
                        </>
                        : null
            }

            <ManualUpgradeModal show={showUpgradeModal} setShow={setShowUpgradeModal} person={props.item} />
            <GeneralModal
                showModal={showLivenessVideoModal}
                maintitle="Liveness Video"
                canceltext="Close"
                notdisableproceed={false}
                setShowModal={setShowLivenessVideoModal}
            >
                {props.item.livenessVideoUrl
                    ? <iframe
                        title={`Liveness video for ${props.item.EMAIL || props.item.fullname1 || 'profile'}`}
                        src={props.item.livenessVideoUrl}
                        className="w-full aspect-video rounded-lg bg-black"
                        allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
                        allowFullScreen
                      />
                    : <p className="text-black">No liveness video URL saved for this profile.</p>
                }
            </GeneralModal>
            <GeneralModal
                showModal={showHideProfileModal}
                maintitle="Hide Profile"
                canceltext="Close"
                notdisableproceed={false}
                setShowModal={setShowHideProfileModal}
            >
                <form className="flex flex-col" onSubmit={handleAddHiddenProfile}>
                    <p className="text-black text-xs mb-2">
                        Add a man's name to {props.item.fullname1 || props.item.EMAIL}'s hidden_profiles list.
                    </p>
                    {menProfilesLoading
                        ? <Loader />
                        : <>
                            <label className="text-black text-xs mb-1" htmlFor={`hidden-profile-select-${props.item.EMAIL}`}>Man to hide</label>
                            <input
                                id={`hidden-profile-select-${props.item.EMAIL}`}
                                list={`hidden-profile-options-${props.item.EMAIL}`}
                                className="border p-2 mb-2 text-black"
                                value={selectedHiddenProfileName}
                                onChange={(e) => setSelectedHiddenProfileName(e.target.value)}
                                placeholder="Search men by name"
                                disabled={menProfilesForHide.length === 0 || hideProfileSubmitting}
                            />
                            <datalist id={`hidden-profile-options-${props.item.EMAIL}`}>
                                {menProfilesForHide.map((profile) => {
                                    const displayName = getProfileDisplayName(profile)
                                    return <option key={profile.EMAIL || displayName} value={displayName}>{displayName}</option>
                                })}
                            </datalist>
                            {menProfilesForHide.length === 0
                                ? <p className="text-black text-xs mb-2">No men profiles found.</p>
                                : null
                            }
                            <button
                                type="submit"
                                className="bg-red-800 text-white p-2 rounded-md disabled:opacity-50"
                                disabled={menProfilesForHide.length === 0 || hideProfileSubmitting}
                            >
                                {hideProfileSubmitting ? 'Adding...' : 'Add'}
                            </button>
                        </>
                    }
                </form>
            </GeneralModal>
            <GeneralModal
                showModal={showEditModal}
                maintitle="Edit Individual Data"
                canceltext="Close"
                notdisableproceed={false}
                setShowModal={setShowEditModal}
            >
                <form className="flex flex-col" onSubmit={handleEditSubmit}>
                    <label className="text-white text-xs mb-1" htmlFor={`field-select-${props.item.EMAIL}-individual`}>Field</label>
                    {editableFields.length > 0
                        ? <select
                            id={`field-select-${props.item.EMAIL}-individual`}
                            className="border p-2 mb-2 text-black"
                            value={selectedField}
                            onChange={handleFieldChange}
                        >
                            {editableFields.map((field) => (
                                <option key={field} value={field}>{field}</option>
                            ))}
                        </select>
                        : <p className="text-white text-xs mb-2">No editable fields available.</p>
                    }
                    <label className="text-white text-xs mb-1" htmlFor={`field-value-${props.item.EMAIL}-individual`}>Value</label>
                    <textarea
                        id={`field-value-${props.item.EMAIL}-individual`}
                        className="border p-2 mb-2 text-black"
                        rows={4}
                        value={fieldValue}
                        onChange={handleValueChange}
                        disabled={editableFields.length === 0}
                    />
                    <button
                        type="submit"
                        className="bg-red-800 text-white p-2 rounded-md disabled:opacity-50"
                        disabled={isSubmitting || editableFields.length === 0}
                    >
                        {isSubmitting ? 'Saving...' : 'Save Changes'}
                    </button>
                </form>
            </GeneralModal>
        </div>
    )
}

function UnactivatedIndividual(props) {
    const [showmatches, setShowMatches] = React.useState(false)
    const [matches, setMatches] = React.useState([])
    const [thepackage, setPackage] = React.useState(props.item.package1)
    const [showUpgradeModal, setShowUpgradeModal] = React.useState(false)
    const [showMenu, setShowMenu] = React.useState(false)
    const [showEditModal, setShowEditModal] = React.useState(false)
    const [selectedField, setSelectedField] = React.useState('')
    const [fieldValue, setFieldValue] = React.useState('')
    const [isSubmitting, setIsSubmitting] = React.useState(false)
    const [isActivating, setIsActivating] = React.useState(false)
    const isMountedRef = React.useRef(true)

    const editableFields = React.useMemo(() => {
        return Object.keys(props.item || {}).filter((key) => key !== '__id')
    }, [props.item])

    React.useEffect(() => {
        return () => {
            isMountedRef.current = false
        }
    }, [])

    React.useEffect(() => {
        if (selectedField && editableFields.includes(selectedField) === false) {
            const fallbackField = editableFields[0] || ''
            setSelectedField(fallbackField)
            setFieldValue(formatFieldValue(props.item?.[fallbackField]))
        }
    }, [editableFields, selectedField])

    React.useEffect(() => {
        if (selectedField) {
            const currentValue = props.item?.[selectedField]
            setFieldValue(formatFieldValue(currentValue))
        }
    }, [props.item, selectedField])

    function formatFieldValue(value) {
        if (value === null || value === undefined) {
            return ''
        }
        if (typeof value === 'object') {
            try {
                return JSON.stringify(value)
            } catch (err) {
                console.error('Failed to stringify field value', err)
                return ''
            }
        }
        return String(value)
    }

    function openEditModal() {
        const fieldToUse = selectedField || editableFields[0] || ''
        if (!fieldToUse) {
            alert('No editable fields found for this profile.')
            return
        }
        setSelectedField(fieldToUse)
        setFieldValue(formatFieldValue(props.item[fieldToUse]))
        setShowEditModal(true)
        setShowMenu(false)
    }

    function handleFieldChange(e) {
        const newField = e.target.value
        setSelectedField(newField)
        setFieldValue(formatFieldValue(props.item[newField]))
    }

    function handleValueChange(e) {
        setFieldValue(e.target.value)
    }

    function handleEditSubmit(e) {
        e.preventDefault()
        
        if (!selectedField) {
            alert('Please choose a field to edit.')
            return
        }

        const updated = { ...props.item }
        
        console.log('Original value:', props.item)
        console.log("Updated before parsing:", updated)

        let newValue = fieldValue
        const original = props.item[selectedField]

        if (typeof original === 'number') {
            const parsed = Number(fieldValue)
            newValue = Number.isNaN(parsed) ? fieldValue : parsed
        } else if (typeof original === 'boolean') {
            newValue = fieldValue === 'true'
        } else if (original !== null && typeof original === 'object') {
            try {
                newValue = JSON.parse(fieldValue)
            } catch (err) {
                console.warn('Could not parse JSON, saving as string instead.', err)
            }
        }

        updated[selectedField] = newValue

        const formdata = new FormData()
        Object.keys(updated).forEach((key) => {
            const value = updated[key]
            if (value === undefined || value === null) {
                formdata.append(key, '')
            } else if (typeof value === 'object') {
                formdata.append(key, JSON.stringify(value))
            } else {
                formdata.append(key, value)
            }
        })

        setIsSubmitting(true)
        const url = '/api/edit_data_purgatory'
        const config = { headers: { 'content-type': 'multipart/form-data' } }

        postData(url, formdata, config).then((data) => {
            if (data.responsecode === 200) {
                alert('Profile updated successfully.')
                props.reload()
                setShowEditModal(false)
            }
        }).catch((error) => {
            console.error('Error updating profile data:', error)
            alert('Failed to update profile data.')
        }).finally(() => {
            setIsSubmitting(false)
        })
    }

    function handleAutoMessage() {
        var formdata = new FormData()
        formdata.append('EMAIL', props.item.EMAIL)
        
        const url = "/api/sirri_api/auto_messages_email"
        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            },
        };
        
        postData(url, formdata, config).then((data) => {
            console.log(data);
            if (data.responsecode === 200) {
                alert(`Auto Messaged. Matches: ${data.matches.length}`);
            } 
        }).catch((error) => {
            console.error("Error fetching purgatory data:", error);
            throw error;
        });
    }

    function messagePerson(item) {
        const requestToken = props.beginChatSelection()

        const menurl = `/api/getprofile/${Base64.encode(item.fullname1)}`;
        const womenmenurl = `/api/getprofile/${Base64.encode(props.item.EMAIL)}`;
        
        loadprofile(
            menurl,
            (profile) => props.resolveChatProfile(requestToken, 'male', profile),
            () => {}
        )
        loadprofile(
            womenmenurl,
            (profile) => props.resolveChatProfile(requestToken, 'female', profile),
            () => {}
        )
        
        props.setIndividualchatvisible(true)
        props.setSelectedChat([])
    }

    async function handlecactivation() {        
        const url = "/api/sirri_api/activate/"+props.item.EMAIL
        const amount = await promptForValidAmount(props.item, 'activation')
        if (!amount) {
            return
        }

        const date = await promptForValidDate(props.item, 'activation')
        if (!date) {
            return
        }

        setIsActivating(true)
        try {
            await submitIncomeLog(props.item, amount, 'BUY', date)
            const data = await fetchData(url)
            console.log(data)
            if (data.responsecode === 200) {
                setMatches(data.matches)
            }
            props.reload()
        } catch (error) {
            console.error("Error fetching purgatory data:", error)
            throw error
        } finally {
            if (isMountedRef.current) {
                setIsActivating(false)
            }
        }
    }

    function handleDelete() {
        var formdata = new FormData();
        formdata.append("EMAIL", props.item.EMAIL);
        const url = "/api/sirri_api/delete_unactivated";
        const config = { headers: { "content-type": "multipart/form-data" } };
        postData(url, formdata, config).then((data) => {
            console.log(data);
            if (data.responsecode === 200) {
                alert("Deleted.");
                props.reload();
            }
        }).catch((error) => {
            console.error("Error fetching purgatory data:", error);
            throw error;
        });
    }

    async function handlePackageChange(value) {
        // let upgradeDetails = null
        // if (value !== props.item.package1) {
        //     upgradeDetails = await promptForUpgradeDetails(props.item)
        //     if (!upgradeDetails) {
        //         return
        //     }
        // }

        setPackage(value)
        var formdata = new FormData()
        formdata.append('EMAIL', props.item.EMAIL)
        formdata.append('package', value)
        const url = "/api/sirri_api/purgatory_change_package"
        const config = { headers: { 'content-type': 'multipart/form-data' } }
        postData(url, formdata, config).then((data) => {
            if (data.responsecode === 200) {
                props.reload()
                setShowMenu(false)
            }
        }).catch((error) => {
            console.error('Error changing package:', error)
        })
    }
    
    return (
        <div className="relative mt-3 mx-4 w-full flex flex-col justify-center items-center border border-white border-1 rounded-sm p-3">
            <button className="absolute top-1 right-1 text-white" onClick={() => setShowMenu(!showMenu)}><MoreVertical size={20} /></button>
            {showMenu && (
                <div className="absolute right-1 top-8 bg-white text-black rounded shadow-md z-10 flex flex-col p-2">
                    <button className="p-1 text-left hover:bg-gray-200" onClick={() => {handleDelete(); setShowMenu(false);}}>Delete</button>
                    <button className="p-1 text-left hover:bg-gray-200" onClick={() => {setShowMatches(!showmatches); setShowMenu(false);}}>{showmatches ? 'Hide Matches' : 'Show Matches'}</button>
                    <button className="p-1 text-left hover:bg-gray-200" onClick={() => {setShowUpgradeModal(true); setShowMenu(false);}}>Record Upgrade</button>
                    <button className="p-1 text-left hover:bg-gray-200" onClick={openEditModal}>Edit Data</button>
                    <select
                        value={thepackage}
                        onChange={(e) => handlePackageChange(e.target.value)}
                        className="border p-1 text-xs my-1"
                    >
                        {packages.map((item, index) => (
                            <option key={index}>{item}</option>
                        ))}
                    </select>
                </div>
            )}
            <div className="w-24 h-24 mb-2 rounded-full overflow-hidden">
                <SmartImageComponent
                    cssclasses="object-cover w-full h-full"
                    src={'/api/profilepic/1?EMAIL='+props.item.EMAIL}
                    backupurl={'/api/profilepic/1?EMAIL='+props.item.EMAIL}
                    backup={true}
                    id={generateUUID()}
                />
            </div>
            
            <p className="text-white text-sm mb-1">Name: {[props.item.firstname1, props.item.middlename1, props.item.lastname1].filter(Boolean).join(' ')} - {props.item.age1}</p>
            <p className="text-white text-xs mb-1">EMAIL: {props.item.EMAIL}</p>       
            <p className="text-white text-xs mb-1">Occupation: {props.item.currentoccupation1}</p>       
            <p className="text-white text-xs mb-1">Package: {thepackage}</p>
            {/* <p className="text-white text-xs mb-1">Financial background: {props.item.financialbackground1}</p>       
            <p className="text-white text-xs mb-1">Marital status: {props.item.familybackground4}</p>     */}

            {/* {props.item.children1
                ? <>
                    {props.item.children1 === "Yes"
                        ? <p className="text-white text-xs mb-1">Kids: {props.item.howmanychildren2}</p>  
                        : <p className="text-white text-xs mb-1">No kids.</p>  
                    }   
                </>
                : null
            }    */}
            
            <button
                className="bg-red-800 text-white p-2 rounded-full w-full text-center disabled:opacity-60"
                onClick={() => handlecactivation()}
                disabled={isActivating}
            >
                {isActivating ? <Loader /> : 'ACTIVATE'}
            </button>
            <ManualUpgradeModal show={showUpgradeModal} setShow={setShowUpgradeModal} person={props.item} />
            <GeneralModal
                showModal={showEditModal}
                maintitle="Edit Individual Data"
                canceltext="Close"
                notdisableproceed={false}
                setShowModal={setShowEditModal}
            >
                <form className="flex flex-col" onSubmit={handleEditSubmit}>
                    <label className="text-white text-xs mb-1" htmlFor={`field-select-${props.item.EMAIL}`}>Field</label>
                    {editableFields.length > 0
                        ? <select
                            id={`field-select-${props.item.EMAIL}`}
                            className="border p-2 mb-2 text-black"
                            value={selectedField}
                            onChange={handleFieldChange}
                        >
                            {editableFields.map((field) => (
                                <option key={field} value={field}>{field}</option>
                            ))}
                        </select>
                        : <p className="text-white text-xs mb-2">No editable fields available.</p>
                    }
                    <label className="text-white text-xs mb-1" htmlFor={`field-value-${props.item.EMAIL}`}>Value</label>
                    <textarea
                        id={`field-value-${props.item.EMAIL}`}
                        className="border p-2 mb-2 text-black"
                        rows={4}
                        value={fieldValue}
                        onChange={handleValueChange}
                        disabled={editableFields.length === 0}
                    />
                    <button
                        type="submit"
                        className="bg-red-800 text-white p-2 rounded-md disabled:opacity-50"
                        disabled={isSubmitting || editableFields.length === 0}
                    >
                        {isSubmitting ? 'Saving...' : 'Save Changes'}
                    </button>
                </form>
            </GeneralModal>
            {showmatches
                ? <div>
                    {matches.map((item, index) => (
                        <button className="bg-black text-white w-full flex flex-col justify-center items-center border border-white border-1 rounded-lg p-4 my-2" key={index} onClick={() => messagePerson(item)}>
                            Message as {item.fullname1}, {item.age1}, {item.package1}
                        </button>
                    ))}
                  </div>
                : null
            }
        </div>
    )
}

function ArchivedIndividual(props) {
    const [thepackage, setPackage] = React.useState(props.item.package1)
    const [showUpgradeModal, setShowUpgradeModal] = React.useState(false)
    const [showMenu, setShowMenu] = React.useState(false)
    function handlecactivation() {
        const url = "/api/sirri_api/activate/"+props.item.EMAIL

        fetchData(url).then((data) => {
            console.log(data);
            alert(`Done.`)
            props.reload();
        })
        .catch((error) => {
            console.error("Error fetching purgatory data:", error);
            throw error;
        });
    }

    async function handlePackageChange(value) {
        let upgradeDetails = null
        if (value !== props.item.package1) {
            upgradeDetails = await promptForUpgradeDetails(props.item)
            if (!upgradeDetails) {
                return
            }
        }

        setPackage(value)
        var formdata = new FormData()
        formdata.append('EMAIL', props.item.EMAIL)
        formdata.append('package', value)
        const url = "/api/sirri_api/purgatory_change_package"
        const config = { headers: { 'content-type': 'multipart/form-data' } }
        postData(url, formdata, config).then((data) => {
            if (data.responsecode === 200) {
                props.reload()
                setShowMenu(false)
            }
        }).catch((error) => {
            console.error('Error changing package:', error)
        })
    }

    function handleSendExpiryEmail() {
        var formdata = new FormData()
        formdata.append('EMAIL', props.item.EMAIL)

        const url = '/api/sirri_api/send_archive_expiry_email'
        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            },
        }

        postData(url, formdata, config).then((data) => {
            if (data.responsecode === 200) {
                alert('Account expiry email sent.')
            } else {
                alert('Failed to send account expiry email.')
            }
            setShowMenu(false)
        }).catch((error) => {
            console.error('Error sending account expiry email:', error)
            alert('Failed to send account expiry email.')
            setShowMenu(false)
        })
    }
    
    return (
        <div className="relative mt-3 mx-4 w-full flex flex-col justify-center items-center border border-white border-1 rounded-sm p-3">
            <button className="absolute top-1 right-1 text-white" onClick={() => setShowMenu(!showMenu)}><MoreVertical size={20} /></button>
            
            {showMenu && (
                <div className="absolute right-1 top-8 bg-white text-black rounded shadow-md z-10 flex flex-col p-2">
                    <select
                        value={thepackage}
                        onChange={(e) => handlePackageChange(e.target.value)}
                        className="border p-1 text-xs my-1"
                    >
                        {packages.map((item, index) => (
                            <option key={index}>{item}</option>
                        ))}
                    </select>
                    <button className="p-1 text-left hover:bg-gray-200" onClick={() => {setShowUpgradeModal(true); setShowMenu(false);}}>Record Upgrade</button>
                    <button className="p-1 text-left hover:bg-gray-200" onClick={handleSendExpiryEmail}>Send Expiry Email</button>
                </div>
            )}
            
            <div className="w-24 h-24 mb-2 rounded-full overflow-hidden">
                <SmartImageComponent
                    cssclasses="object-cover w-full h-full"
                    src={'/api/profilepic/1?EMAIL='+props.item.EMAIL}
                    backupurl={'/api/profilepic/1?EMAIL='+props.item.EMAIL}
                    backup={true}
                    id={generateUUID()}
                />
            </div>
            
            <p className="text-white text-sm mb-1">Name: {[props.item.firstname1, props.item.middlename1, props.item.lastname1].filter(Boolean).join(' ')} - {props.item.age1}</p>
            <p className="text-white text-xs mb-1">EMAIL: {props.item.EMAIL}</p>       
            
            <button className="bg-red-800 text-white p-2 rounded-full w-full text-center" onClick={() => handlecactivation()}>REACTIVATE</button>
            <ManualUpgradeModal show={showUpgradeModal} setShow={setShowUpgradeModal} person={props.item} />
        </div>
    )
}

export function PurgatoryActivations() {
    const [profiles, setProfiles] = React.useState([])
    const [activatedprofiles, setActivatedProfiles] = React.useState([])
    const [archivedprofiles, setArchivedProfiles] = React.useState([])
    const [loading, setLoading] = React.useState(false)
    const [search, setSearch] = React.useState('');
    const [search2, setSearch2] = React.useState('');
    const [showUnactivatedProfiles, setShowUnactivatedProfiles] = React.useState(false)
    const [showOnlyLivenessProfiles, setShowOnlyLivenessProfiles] = React.useState(false)
    const [activatedLimit, setActivatedLimit] = React.useState(20);

    const [menprofiles, setMenProfile] = React.useState([])
    const [selectedchat, setSelectedChat] = React.useState([])

    const [maledata, maleData] = React.useState([])
    const [maleloading, setmaleLoading] = React.useState(false)

    const [femaledata, femaleData] = React.useState([])
    const [femaleloading, setfemaleLoading] = React.useState(false)

    const [individualchatvisible, setIndividualchatvisible] = React.useState(false)
    const [callSignal, setCallSignal] = React.useState(0)
    const chatSelectionTrackerRef = React.useRef(createChatSelectionTracker())
    const activatedLoaderRef = React.useRef(null);
    const activatedDelayTimeout = React.useRef(null);

    async function load(reload) {
        if (!reload) setLoading(true)

        try {
            // const archiveSummary = await fetchData('/api/sirri_api/archive_inactive_women')

            const [purgatoryData, womenData, hiddenPurgatoryData] = await Promise.all([
                fetchData('/api/sirri_api/get_purgatory'),
                fetchData('/api/sirri_api/get_women'),
                fetchData('/api/sirri_api/get_hidden_purgatory'),
            ])

            if (purgatoryData.responsecode === 200) {
                setProfiles(purgatoryData.acc)
            }

            if (womenData.responsecode === 200) {
                setActivatedProfiles(womenData.acc)
                setActivatedLimit(20)
            }

            if (hiddenPurgatoryData.responsecode === 200) {
                setArchivedProfiles(hiddenPurgatoryData.acc)
            }
        } catch (error) {
            console.error('Error loading activation dashboard data:', error)
            throw error
        } finally {
            setLoading(false)
        }
    }

    React.useEffect(() => {
        load()
    }, [])

    const filteredActivatedProfiles = React.useMemo(() => {
        const lowerSearch = search;
        return [...activatedprofiles]
            .sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0))
            .filter((item) => {
                if (showOnlyLivenessProfiles && !item.livenessVideoUrl) {
                    return false;
                }
                const name = item.fullname1 || '';
                const email = item.EMAIL || '';
                return name.includes(lowerSearch) || email.includes(lowerSearch) || lowerSearch === '';
            });
    }, [activatedprofiles, search, showOnlyLivenessProfiles]);

    const displayedActivatedProfiles = React.useMemo(
        () => filteredActivatedProfiles.slice(0, activatedLimit),
        [filteredActivatedProfiles, activatedLimit]
    );

    const hasMoreActivatedProfiles = filteredActivatedProfiles.length > activatedLimit;

    React.useEffect(() => {
        setActivatedLimit(20);
    }, [search, showOnlyLivenessProfiles]);

    React.useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            const entry = entries[0];
            if (entry.isIntersecting && !loading && hasMoreActivatedProfiles) {
                activatedDelayTimeout.current = setTimeout(() => {
                    setActivatedLimit((prev) => prev + 20);
                }, 500);
            }
        });

        const node = activatedLoaderRef.current;
        if (node) observer.observe(node);

        return () => {
            observer.disconnect();
            if (activatedDelayTimeout.current) {
                clearTimeout(activatedDelayTimeout.current);
            }
        };
    }, [loading, hasMoreActivatedProfiles]);

    React.useEffect(() => () => {
        if (activatedDelayTimeout.current) {
            clearTimeout(activatedDelayTimeout.current);
        }
    }, []);

    function handleActivatedLoadMore() {
        setActivatedLimit((prev) => prev + 20);
    }

    function beginChatSelection() {
        setmaleLoading(true)
        setfemaleLoading(true)
        maleData([])
        femaleData([])
        return chatSelectionTrackerRef.current.beginSelection()
    }

    function resolveChatProfile(token, role, profile) {
        const response = chatSelectionTrackerRef.current.resolveProfile(token, role, profile)
        if (!response.applied) {
            return
        }

        if (response.ready) {
            maleData(response.pair.male)
            femaleData(response.pair.female)
            setmaleLoading(false)
            setfemaleLoading(false)
        }
    }

    return (
        <>
        {maleloading === false && femaleloading === false
                ? <GeneralModal
                        showModal={individualchatvisible} maintitle={maledata.fullname1 || ""}
                        notdisableproceed={false} canceltext="Back"
                        setShowModal={setIndividualchatvisible}
                        lilbutton={true} lilbuttonlink={'/profilen/'+Base64.encode(maledata.fullname1) || ''}
                        lilbuttontext="View Profile"
                        middlebutton={true}
                        middlebuttontext="Call"
                        middlebuttonicon="📞"
                        onMiddleButtonClick={() => {
                            primeCallAudioFromUserGesture();
                            setCallSignal((prev) => prev + 1);
                        }}
                  >
                    <ChatInterfaceMan
                            womandata={femaledata}
                            male={maledata}
                            chatdata={selectedchat}
                            gender={"Male"}
                            activation={true}
                            callSignal={callSignal}
                    />
                  </GeneralModal>
                : null
        }


        <div className="flex flex-col items-center justify-center">
            <Link className="bg-red-800 text-white p-2 rounded-full text-xl my-2" href={"/sirri_api/mensdashboard"}>Change Mens Packages</Link>
            <input className="bg-white text-black placeholder-gray-600 p-2 my-2  w-full rounded-full" placeholder="Search for a specific woman:" onChange={(e) => setSearch2(e.target.value.toLowerCase())}/>

            {profiles.length === 0 ? null
                : <div className="flex items-center gap-2 mt-2">
                    <button
                        className="bg-white text-2xl text-black px-3 py-1 rounded-full"
                        onClick={() => setShowUnactivatedProfiles((current) => !current)}
                    >
                        {showUnactivatedProfiles ? 'Hide Unactivated Profiles' : 'Show Unactivated Profiles'}
                    </button>
                  </div>
            }

            {showUnactivatedProfiles
                ? loading
                    ? <Loader />
                    : <div className="w-full grid grid-cols-2 md:grid-cols-4 gap-2">
                        {profiles.sort((a, b) => b.timestamp - a.timestamp1).map(function (item, index) {
                            if ((item.fullname1?.includes(search2)) || (item.EMAIL?.includes(search2)) || search2 === '') {
                                return <UnactivatedIndividual
                                            item={item}
                                            setSelectedChat={setSelectedChat}
                                            maleData={maleData}
                                            femaleData={femaleData}
                                            setmaleLoading={setmaleLoading}
                                            setfemaleLoading={setfemaleLoading}
                                            setIndividualchatvisible={setIndividualchatvisible}
                                            beginChatSelection={beginChatSelection}
                                            resolveChatProfile={resolveChatProfile}
                                            key={index}
                                            reload={() => load(true)}
                                        />
                            }
                        })}
                      </div>
                : null
            }

            <p className="text-2xl text-white mt-5">Activated Profiles</p>
            <div className="flex items-center gap-2 my-2">
                <button
                    className={showOnlyLivenessProfiles ? "bg-emerald-700 text-white px-3 py-1 rounded-full" : "bg-white text-black px-3 py-1 rounded-full"}
                    onClick={() => setShowOnlyLivenessProfiles((current) => !current)}
                >
                    {showOnlyLivenessProfiles ? 'Showing Liveness Videos Only' : 'Show Liveness Videos Only'}
                </button>
            </div>
            <input className="bg-white text-black placeholder-gray-600 p-2 my-2  w-full rounded-full" placeholder="Search for a specific woman:" onChange={(e) => setSearch(e.target.value.toLowerCase())}/>
            {loading
                ? <Loader />
                : <div className="w-full grid grid-cols-2 md:grid-cols-4 gap-2">
                    {displayedActivatedProfiles.map(function(item, index) {
                        return <IndividualIndividual item={item} key={index} reload={() => load(true)}/>;
                    })}
                  </div>
            }
            {hasMoreActivatedProfiles && !loading && (
                <button className="my-2 px-4 py-2 bg-transparent text-white rounded" onClick={handleActivatedLoadMore}>
                    <Loader/>
                </button>
            )}
            <div ref={activatedLoaderRef} />

        </div>
        </>
    )
}

export function ArchivedProfiles() {
    const [archivedprofiles, setArchivedProfiles] = React.useState([])
    const [loading, setLoading] = React.useState(false)
    const [search, setSearch] = React.useState('')
    const [archivedLimit, setArchivedLimit] = React.useState(20)
    const archivedLoaderRef = React.useRef(null)
    const archivedDelayTimeout = React.useRef(null)

    function load(reload) {
        if (!reload) setLoading(true)
        fetchData('/api/sirri_api/get_hidden_purgatory').then((data) => {
            if (data.responsecode === 200) {
                setArchivedProfiles(data.acc)
                setArchivedLimit(20)
            }
            setLoading(false)
        })
        .catch((error) => {
            console.error('Error fetching purgatory data:', error)
            throw error
        })
    }

    React.useEffect(load, [])

    const filteredArchivedProfiles = React.useMemo(() => {
        return [...archivedprofiles]
            .sort((a, b) => b.timestamp - a.timestamp)
            .filter((item) => {
                return (item.fullname1?.includes(search)) || item.EMAIL?.includes(search) || search === ''
            })
    }, [archivedprofiles, search])

    const displayedArchivedProfiles = React.useMemo(
        () => filteredArchivedProfiles.slice(0, archivedLimit),
        [filteredArchivedProfiles, archivedLimit]
    )

    const hasMoreArchivedProfiles = filteredArchivedProfiles.length > archivedLimit

    React.useEffect(() => {
        setArchivedLimit(20)
    }, [search])

    React.useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            const entry = entries[0]
            if (entry.isIntersecting && !loading && hasMoreArchivedProfiles) {
                archivedDelayTimeout.current = setTimeout(() => {
                    setArchivedLimit((prev) => prev + 20)
                }, 250)
            }
        })

        const node = archivedLoaderRef.current
        if (node) observer.observe(node)

        return () => {
            if (node) observer.unobserve(node)
            if (archivedDelayTimeout.current) {
                clearTimeout(archivedDelayTimeout.current)
            }
        }
    }, [loading, hasMoreArchivedProfiles])

    React.useEffect(() => {
        return () => {
            if (archivedDelayTimeout.current) {
                clearTimeout(archivedDelayTimeout.current)
            }
        }
    }, [])

    function handleArchivedLoadMore() {
        setArchivedLimit((prev) => prev + 20)
    }

    return (
        <div className="flex flex-col items-center justify-center">
            <input
                className="bg-white text-black placeholder-gray-600 p-2 my-2 w-full rounded-full"
                placeholder="Search for a specific woman:"
                onChange={(e) => setSearch(e.target.value.toLowerCase())}
            />
            {loading
                ? <p className="text-base text-white">Loading</p>
                : <>
                    <div className="w-full grid grid-cols-1 md:grid-cols-4 gap-2">
                        {displayedArchivedProfiles.map(function(item, index) {
                            return <ArchivedIndividual item={item} key={index} reload={() => load(true)}/>
                        })}
                    </div>
                    {hasMoreArchivedProfiles && !loading && (
                        <button className="my-2 px-4 py-2 bg-transparent text-white rounded" onClick={handleArchivedLoadMore}>
                            Load more archived profiles
                        </button>
                    )}
                    <div ref={archivedLoaderRef} />
                  </>
            }
        </div>
    )
}

export function DeletedProfiles() {
    const [deletedprofiles, setDeletedProfiles] = React.useState([])
    const [loading, setLoading] = React.useState(false)
    const [search, setSearch] = React.useState('')

    function load(reload) {
        if (!reload) setLoading(true)
        fetchData('/api/sirri_api/get_deleted_profiles').then((data) => {
            if (data.responsecode === 200) {
                setDeletedProfiles(data.acc)
            }
            setLoading(false)
        })
        .catch((error) => {
            console.error('Error fetching deleted profiles:', error)
            throw error
        })
    }

    React.useEffect(load, [])

    return (
        <div className="flex flex-col items-center justify-center">
            <input
                className="bg-white text-black placeholder-gray-600 p-2 my-2 w-full rounded-full"
                placeholder="Search for a specific woman:"
                onChange={(e) => setSearch(e.target.value.toLowerCase())}
            />
            {loading
                ? <p className="text-base text-white">Loading</p>
                : <div className="w-full grid grid-cols-1 md:grid-cols-4 gap-2">
                    {deletedprofiles.sort((a, b) => b.timestamp - a.timestamp).map(function(item, index) {
                        if ((item.fullname1?.includes(search)) || item.EMAIL?.includes(search) || search === '') {
                            return <ArchivedIndividual item={item} key={index} reload={() => load(true)}/>
                        }
                    })}
                  </div>
            }
        </div>
    )
}
